{
  "about.blocks": "Servidores moderados",
  "about.contact": "Contacto:",
  "about.default_locale": "Por defecto",
  "about.disclaimer": "Mastodon es un software libre, de código abierto, y una marca comercial de Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Motivo no disponible",
  "about.domain_blocks.preamble": "Mastodon generalmente te permite ver contenido e interactuar con usuarios de cualquier otro servidor del fediverso. Estas son las excepciones que se han hecho en este servidor en particular.",
  "about.domain_blocks.silenced.explanation": "Por lo general, no verás perfiles ni contenidos de este servidor, a menos que los busques explícitamente o que optes por seguirlo.",
  "about.domain_blocks.silenced.title": "Limitado",
  "about.domain_blocks.suspended.explanation": "Ningún dato de este servidor será procesado, almacenado o intercambiado, haciendo cualquier interacción o comunicación con los usuarios de este servidor imposible.",
  "about.domain_blocks.suspended.title": "Suspendido",
  "about.language_label": "Idioma",
  "about.not_available": "Esta información no está disponible en este servidor.",
  "about.powered_by": "Medio social descentralizado con tecnología de {mastodon}",
  "about.rules": "Reglas del servidor",
  "account.account_note_header": "Nota personal",
  "account.activity": "Actividad",
  "account.add_note": "Añadir una nota personal",
  "account.add_or_remove_from_list": "Agregar o eliminar de las listas",
  "account.badges.admin": "Administrador",
  "account.badges.blocked": "Bloqueado",
  "account.badges.bot": "Automatizada",
  "account.badges.domain_blocked": "Dominio bloqueado",
  "account.badges.group": "Grupo",
  "account.badges.muted": "Silenciado",
  "account.badges.muted_until": "Silenciado hasta {until}",
  "account.block": "Bloquear a @{name}",
  "account.block_domain": "Bloquear dominio {domain}",
  "account.block_short": "Bloquear",
  "account.blocked": "Bloqueado",
  "account.cancel_follow_request": "Cancelar seguimiento",
  "account.copy": "Copiar enlace al perfil",
  "account.direct": "Mención privada @{name}",
  "account.disable_notifications": "Dejar de notificarme cuando @{name} publique algo",
  "account.edit_note": "Editar nota personal",
  "account.edit_profile": "Editar perfil",
  "account.edit_profile_short": "Editar",
  "account.enable_notifications": "Notificarme cuando @{name} publique algo",
  "account.endorse": "Destacar en mi perfil",
  "account.familiar_followers_many": "Seguido por {name1}, {name2} y {othersCount, plural,one {# más que conoces}other {# más que conoces}}",
  "account.familiar_followers_one": "Seguido por {name1}",
  "account.familiar_followers_two": "Seguid por {name1} y {name2}",
  "account.featured": "Destacado",
  "account.featured.accounts": "Perfiles",
  "account.featured.collections": "Colecciones",
  "account.featured.new_collection": "Nueva colección",
  "account.field_overflow": "Mostrar contenido completo",
  "account.filters.all": "Toda la actividad",
  "account.filters.boosts_toggle": "Mostrar impulsos",
  "account.filters.posts_boosts": "Publicaciones e impulsos",
  "account.filters.posts_only": "Publicaciones",
  "account.filters.posts_replies": "Publicaciones y respuestas",
  "account.filters.replies_toggle": "Mostrar respuestas",
  "account.follow": "Seguir",
  "account.follow_back": "Seguir también",
  "account.follow_back_short": "Seguir también",
  "account.follow_request": "Solicitar seguimiento",
  "account.follow_request_cancel": "Cancelar solicitud",
  "account.follow_request_cancel_short": "Cancelar",
  "account.follow_request_short": "Solicitar",
  "account.followers": "Seguidores",
  "account.followers.empty": "Nadie sigue a este usuario todavía.",
  "account.followers_counter": "{count, plural, one {{counter} seguidor} other {{counter} seguidores}}",
  "account.followers_you_know_counter": "{counter} que conoces",
  "account.following": "Siguiendo",
  "account.following_counter": "{count, plural, one {{counter} siguiendo} other {{counter} siguiendo}}",
  "account.follows.empty": "Este usuario no sigue a nadie todavía.",
  "account.follows_you": "Te sigue",
  "account.go_to_profile": "Ir al perfil",
  "account.hide_reblogs": "Ocultar impulsos de @{name}",
  "account.in_memoriam": "En memoria.",
  "account.join_modal.day": "Día",
  "account.join_modal.me": "Te uniste a {server} el",
  "account.join_modal.me_anniversary": "¡Feliz Fediversario! Te uniste a {server} el",
  "account.join_modal.me_today": "¡Es tu primer día en {server}!",
  "account.join_modal.other": "{name} se unió a {server} el",
  "account.join_modal.other_today": "¡Es el primer día de {name} en {server}!",
  "account.join_modal.share.celebrate": "Compartir una publicación para celebrarlo",
  "account.join_modal.share.intro": "Compartir una publicación de presentación",
  "account.join_modal.share.welcome": "Compartir una publicación de bienvenida",
  "account.join_modal.years": "{number, plural, one {año} other {# años}}",
  "account.joined_short": "Se unió",
  "account.languages": "Cambiar idiomas suscritos",
  "account.last_active": "Última actividad",
  "account.link_verified_on": "Se verificó la propiedad de este enlace el {date}",
  "account.locked_info": "El estado de privacidad de esta cuenta está configurado como bloqueado. El propietario revisa manualmente quién puede seguirlo.",
  "account.media": "Multimedia",
  "account.mention": "Mencionar a @{name}",
  "account.menu.add_to_collection": "Añadir a colección…",
  "account.menu.add_to_list": "Añadir a lista…",
  "account.menu.block": "Bloquear cuenta",
  "account.menu.block_domain": "Bloquear {domain}",
  "account.menu.copied": "Enlace de la cuenta copiado al portapapeles",
  "account.menu.copy": "Copiar enlace",
  "account.menu.direct": "Mencionar en privado",
  "account.menu.hide_reblogs": "Ocultar impulsos en la cronología",
  "account.menu.mention": "Mencionar",
  "account.menu.mute": "Silenciar cuenta",
  "account.menu.note.description": "Visible solo para ti",
  "account.menu.open_original_page": "Ver en {domain}",
  "account.menu.remove_follower": "Eliminar seguidor",
  "account.menu.report": "Denunciar cuenta",
  "account.menu.share": "Compartir…",
  "account.menu.show_reblogs": "Mostrar impulsos en la cronología",
  "account.menu.unblock": "Desbloquear cuenta",
  "account.menu.unblock_domain": "Desbloquear {domain}",
  "account.menu.unmute": "Dejar de silenciar cuenta",
  "account.moved_to": "{name} ha indicado que su nueva cuenta es ahora:",
  "account.mute": "Silenciar a @{name}",
  "account.mute_notifications_short": "Silenciar notificaciones",
  "account.mute_short": "Silenciar",
  "account.muted": "Silenciado",
  "account.mutual": "Se siguen el uno al otro",
  "account.name.copy": "Copiar identificador",
  "account.name.help.domain": "{domain} es el servidor que aloja el perfil y las publicaciones del usuario.",
  "account.name.help.domain_self": "{domain} es el servidor que aloja tu perfil y tus publicaciones.",
  "account.name.help.footer": "Al igual que puedes enviar correos electrónicos a personas que utilizan diferentes proveedores de correo electrónico, puedes interactuar con personas de otros servidores de Mastodon y con cualquier usuario de otras aplicaciones del Fediverso.",
  "account.name.help.header": "Un identificador es como una dirección de correo electrónico",
  "account.name.help.username": "{username} es el nombre de usuario de esta cuenta en su servidor. Es posible que alguien en otro servidor tenga el mismo nombre de usuario.",
  "account.name.help.username_self": "{username} es tu nombre de usuario en este servidor. Es posible que alguien en otro servidor tenga el mismo nombre de usuario.",
  "account.name_info": "¿Qué significa esto?",
  "account.no_bio": "Sin biografía.",
  "account.node_modal.callout": "Las notas personales solo son visibles para ti.",
  "account.node_modal.edit_title": "Editar nota personal",
  "account.node_modal.error_unknown": "No se pudo guardar la nota",
  "account.node_modal.field_label": "Nota personal",
  "account.node_modal.save": "Guardar",
  "account.node_modal.title": "Añadir una nota personal",
  "account.note.edit_button": "Editar",
  "account.note.title": "Nota personal (visible solo para ti)",
  "account.open_original_page": "Abrir página original",
  "account.pending": "Pendiente",
  "account.posts": "Publicaciones",
  "account.remove_from_followers": "Eliminar {name} de tus seguidores",
  "account.report": "Denunciar a @{name}",
  "account.requested_follow": "{name} ha solicitado seguirte",
  "account.share": "Compartir el perfil de @{name}",
  "account.show_reblogs": "Mostrar impulsos de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} publicación} other {{counter} publicaciones}}",
  "account.timeline.pinned": "Fijada",
  "account.timeline.pinned.view_all": "Ver todas las publicaciones fijadas",
  "account.unblock": "Desbloquear a @{name}",
  "account.unblock_domain": "Mostrar a {domain}",
  "account.unblock_domain_short": "Desbloquear",
  "account.unblock_short": "Desbloquear",
  "account.unendorse": "No mostrar en el perfil",
  "account.unfollow": "Dejar de seguir",
  "account.unmute": "Dejar de silenciar a @{name}",
  "account.unmute_notifications_short": "Dejar de silenciar notificaciones",
  "account.unmute_short": "Dejar de silenciar",
  "account_edit.advanced_settings.bot_hint": "Indica a los demás que la cuenta realiza principalmente acciones automatizadas y que es posible que no esté supervisada",
  "account_edit.advanced_settings.bot_label": "Cuenta automatizada",
  "account_edit.advanced_settings.title": "Configuración avanzada",
  "account_edit.bio.add_label": "Añadir biografía",
  "account_edit.bio.edit_label": "Editar biografía",
  "account_edit.bio.placeholder": "Añade una breve introducción para ayudar a los demás a identificarte.",
  "account_edit.bio.title": "Biografía",
  "account_edit.bio_modal.add_title": "Añadir biografía",
  "account_edit.bio_modal.edit_title": "Editar biografía",
  "account_edit.column_button": "Hecho",
  "account_edit.column_title": "Editar perfil",
  "account_edit.custom_fields.add_label": "Añadir campo",
  "account_edit.custom_fields.edit_label": "Editar campo",
  "account_edit.custom_fields.placeholder": "Añade tus pronombres, enlaces externos o cualquier otra información que quieras compartir.",
  "account_edit.custom_fields.reorder_button": "Reordenar campos",
  "account_edit.custom_fields.tip_content": "Puedes añadir fácilmente credibilidad a tu cuenta de Mastodon verificando los enlaces a cualquier sitio web que poseas.",
  "account_edit.custom_fields.tip_title": "Consejo: Añadir enlaces verificados",
  "account_edit.custom_fields.title": "Campos personalizados",
  "account_edit.custom_fields.verified_hint": "¿Cómo añado un enlace verificado?",
  "account_edit.display_name.add_label": "Añadir nombre para mostrar",
  "account_edit.display_name.edit_label": "Editar nombre para mostrar",
  "account_edit.display_name.placeholder": "Tu nombre de usuario es el nombre que aparece en tu perfil y en las líneas de tiempo.",
  "account_edit.display_name.title": "Nombre para mostrar",
  "account_edit.featured_hashtags.edit_label": "Añadir etiquetas",
  "account_edit.featured_hashtags.placeholder": "Ayuda a otros a identificar tus temas favoritos y a acceder rápidamente a ellos.",
  "account_edit.featured_hashtags.title": "Etiquetas destacadas",
  "account_edit.field_actions.delete": "Eliminar campo",
  "account_edit.field_actions.edit": "Editar campo",
  "account_edit.field_delete_modal.confirm": "¿Estás seguro de que deseas eliminar este campo personalizado? Esta acción no se puede deshacer.",
  "account_edit.field_delete_modal.delete_button": "Eliminar",
  "account_edit.field_delete_modal.title": "¿Eliminar campo personalizado?",
  "account_edit.field_edit_modal.add_title": "Agregar campo personalizado",
  "account_edit.field_edit_modal.discard_confirm": "Descartar",
  "account_edit.field_edit_modal.discard_message": "Tienes cambios sin guardar. ¿Estás seguro/a de que quieres descartarlos?",
  "account_edit.field_edit_modal.edit_title": "Editar campo personalizado",
  "account_edit.field_edit_modal.length_warning": "Se ha superado el límite de caracteres recomendado. Es posible que los usuarios de dispositivos móviles no vean el campo completo.",
  "account_edit.field_edit_modal.link_emoji_warning": "No recomendamos el uso de emojis personalizados en combinación con direcciones URL. Los campos personalizados que contengan ambos se mostrarán solo como texto en lugar de como un enlace, con el fin de evitar confusiones al usuario.",
  "account_edit.field_edit_modal.name_hint": "Por ejemplo, «sitio web personal»",
  "account_edit.field_edit_modal.name_label": "Etiqueta",
  "account_edit.field_edit_modal.url_warning": "Para agregar un enlace, incluye {protocol} al principio.",
  "account_edit.field_edit_modal.value_hint": "Por ejemplo: “https://ejemplo.me”",
  "account_edit.field_edit_modal.value_label": "Valor",
  "account_edit.field_reorder_modal.drag_cancel": "Se canceló el arrastre. Se eliminó el campo «{item}».",
  "account_edit.field_reorder_modal.drag_end": "Se ha eliminado el campo «{item}».",
  "account_edit.field_reorder_modal.drag_instructions": "Para reorganizar los campos personalizados, presiona la barra espaciadora o Intro. Mientras arrastras, utiliza las teclas de flecha para mover el campo hacia arriba o hacia abajo. Presiona la barra espaciadora o Intro de nuevo para soltar el campo en su nueva posición, o presiona Esc para cancelar.",
  "account_edit.field_reorder_modal.drag_move": "Se ha movido el campo «{item}».",
  "account_edit.field_reorder_modal.drag_over": "El campo «{item}» se ha movido a «{over}».",
  "account_edit.field_reorder_modal.drag_start": "Recogido el campo «{item}».",
  "account_edit.field_reorder_modal.handle_label": "Arrastra el campo «{item}»",
  "account_edit.field_reorder_modal.title": "Reorganizar campos",
  "account_edit.image_alt_modal.add_title": "Añadir texto alternativo",
  "account_edit.image_alt_modal.details_content": "QUÉ HACER: <ul><li>Descríbete tal y como apareces en la imagen</li><li>Utiliza la tercera persona (p. ej., «Alex» en lugar de «yo»)</li><li>Sé conciso: unas pocas palabras suelen bastar</li></ul>QUÉ NO HACER: <ul><li>Empezar con «Foto de»: es redundante para los lectores de pantalla</li></ul> EJEMPLO: <ul><li>«Alex usando una camiseta verde y anteojos»</li></ul>",
  "account_edit.image_alt_modal.details_title": "Consejo: Texto alternativo para las fotos de perfil",
  "account_edit.image_alt_modal.edit_title": "Editar texto alternativo",
  "account_edit.image_alt_modal.text_hint": "El texto alternativo ayuda a los usuarios de lectores de pantalla a entender tu contenido.",
  "account_edit.image_alt_modal.text_label": "Texto alternativo",
  "account_edit.image_delete_modal.confirm": "¿Estás seguro de que quieres eliminar esta imagen? Esta acción no se puede deshacer.",
  "account_edit.image_delete_modal.delete_button": "Eliminar",
  "account_edit.image_delete_modal.title": "¿Eliminar imagen?",
  "account_edit.image_edit.add_button": "Añadir imagen",
  "account_edit.image_edit.alt_add_button": "Añadir texto alternativo",
  "account_edit.image_edit.alt_edit_button": "Editar texto alternativo",
  "account_edit.image_edit.remove_button": "Eliminar imagen",
  "account_edit.image_edit.replace_button": "Reemplazar imagen",
  "account_edit.item_list.delete": "Eliminar {name}",
  "account_edit.item_list.edit": "Editar {name}",
  "account_edit.name_modal.add_title": "Añadir nombre para mostrar",
  "account_edit.name_modal.edit_title": "Editar nombre para mostrar",
  "account_edit.profile_tab.button_label": "Personalizar",
  "account_edit.profile_tab.hint.description": "Esta configuración personaliza lo que los usuarios ven en {server} en las aplicaciones oficiales, pero es posible que no se aplique a los usuarios de otros servidores y aplicaciones de terceros.",
  "account_edit.profile_tab.hint.title": "Las pantallas todavía varían",
  "account_edit.profile_tab.show_featured.description": "«Destacados» es una pestaña opcional en la que puedes mostrar otras cuentas.",
  "account_edit.profile_tab.show_featured.title": "Mostrar la pestaña «Destacados»",
  "account_edit.profile_tab.show_media.description": "«Multimedia» es una pestaña opcional que muestra tus publicaciones que contienen imágenes o videos.",
  "account_edit.profile_tab.show_media.title": "Mostrar pestaña «Multimedia»",
  "account_edit.profile_tab.show_media_replies.description": "Cuando está habilitada, la pestaña Multimedia muestra tanto tus publicaciones como tus respuestas a las publicaciones de otras personas.",
  "account_edit.profile_tab.show_media_replies.title": "Incluir respuestas en la pestaña «Multimedia»",
  "account_edit.profile_tab.show_relations.description": "Muestra en tu perfil las cuentas a las que sigues y los usuarios que te siguen. Las personas seguirán pudiendo ver si los sigues.",
  "account_edit.profile_tab.show_relations.title": "Mostrar «Seguidores» y «Siguiendo»",
  "account_edit.profile_tab.subtitle": "Personaliza la forma en que se muestra tu perfil.",
  "account_edit.profile_tab.title": "Configuración de visualización del perfil",
  "account_edit.save": "Guardar",
  "account_edit.upload_modal.back": "Volver",
  "account_edit.upload_modal.done": "Hecho",
  "account_edit.upload_modal.next": "Siguiente",
  "account_edit.upload_modal.step_crop.zoom": "Acercar",
  "account_edit.upload_modal.step_upload.button": "Explorar archivos",
  "account_edit.upload_modal.step_upload.dragging": "Arrastrar para subir",
  "account_edit.upload_modal.step_upload.header": "Elegir una imagen",
  "account_edit.upload_modal.step_upload.hint": "Formato WEBP, PNG, GIF o JPG, con un tamaño máximo de {limit} MB.{br}La imagen se redimensionará a {width} x {height} píxeles.",
  "account_edit.upload_modal.title_add.avatar": "Añadir foto de perfil",
  "account_edit.upload_modal.title_add.header": "Añadir foto de cabecera",
  "account_edit.upload_modal.title_replace.avatar": "Reemplazar foto de perfil",
  "account_edit.upload_modal.title_replace.header": "Reemplazar foto de cabecera",
  "account_edit.verified_modal.details": "Agrega credibilidad a tu perfil de Mastodon verificando los enlaces a sitios web personales. Así es como funciona:",
  "account_edit.verified_modal.invisible_link.details": "Agrega el enlace a tu encabezado. La parte importante es rel=\"me\", que evita la suplantación de identidad en sitios web con contenido generado por los usuarios. Incluso puedes usar una etiqueta de enlace en el encabezado de la página en lugar de {tag}, pero el HTML debe ser accesible sin ejecutar JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "¿Cómo hago para que el enlace sea invisible?",
  "account_edit.verified_modal.step1.header": "Copia el código HTML que aparece a continuación y pégalo en el encabezado de tu sitio web",
  "account_edit.verified_modal.step2.details": "Si ya has agregado tu sitio web como campo personalizado, deberás eliminarlo y volver a agregarlo para activar la verificación.",
  "account_edit.verified_modal.step2.header": "Agrega tu sitio web como campo personalizado",
  "account_edit.verified_modal.title": "Cómo agregar un enlace verificado",
  "account_edit_tags.add_tag": "Añadir #{tagName}",
  "account_edit_tags.column_title": "Editar etiquetas",
  "account_edit_tags.help_text": "Las etiquetas destacadas ayudan a los usuarios a descubrir tu perfil e interactuar con él. Aparecen como filtros en la vista Actividad de tu página de perfil.",
  "account_edit_tags.max_tags_reached": "Has alcanzado el número máximo de etiquetas destacadas.",
  "account_edit_tags.search_placeholder": "Introduce una etiqueta…",
  "account_edit_tags.suggestions": "Sugerencias:",
  "account_edit_tags.tag_status_count": "{count, plural,one {# publicación} other {# publicaciones}}",
  "account_list.hidden_notice": "Esto solo lo puedes ver tú. Para mostrar esta lista a otras personas, ve a <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural,one {# cuenta} other {# cuentas}}",
  "admin.dashboard.daily_retention": "Tasa de retención de usuarios por día después de unirse",
  "admin.dashboard.monthly_retention": "Tasa de retención de usuarios por mes después de unirse",
  "admin.dashboard.retention.average": "Promedio",
  "admin.dashboard.retention.cohort": "Mes de registro",
  "admin.dashboard.retention.cohort_size": "Nuevos usuarios",
  "admin.impact_report.instance_accounts": "Cuentas que se verían eliminadas",
  "admin.impact_report.instance_followers": "Seguidores que nuestros usuarios perderían",
  "admin.impact_report.instance_follows": "Seguidores que perderían sus usuarios",
  "admin.impact_report.title": "Resumen de impacto",
  "alert.need_reload.message": "Se ha actualizado Mastodon. Es posible que algunas cosas no funcionen correctamente hasta que refresques la página.",
  "alert.rate_limited.message": "Por favor, intenta después de las {retry_time, time, medium}.",
  "alert.rate_limited.title": "Tarifa limitada",
  "alert.unexpected.message": "Hubo un error inesperado.",
  "alert.unexpected.title": "¡Uy!",
  "alt_text_badge.title": "Texto alternativo",
  "alt_text_modal.add_alt_text": "Añadir texto alternativo",
  "alt_text_modal.add_text_from_image": "Añadir texto de la imagen",
  "alt_text_modal.cancel": "Cancelar",
  "alt_text_modal.change_thumbnail": "Cambiar miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Describe esto para personas con discapacidad auditiva…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Describe esto para personas con discapacidad visual…",
  "alt_text_modal.done": "Hecho",
  "announcement.announcement": "Anuncio",
  "annual_report.announcement.action_build": "Preparar mi Wrapstodon",
  "annual_report.announcement.action_dismiss": "No, gracias",
  "annual_report.announcement.action_view": "Ver mi Wrapstodon",
  "annual_report.announcement.description": "Descubre más sobre tu participación en Mastodon durante el último año.",
  "annual_report.announcement.title": "Wrapstodon {year} ha llegado",
  "annual_report.nav_item.badge": "Nueva",
  "annual_report.shared_page.donate": "Donar",
  "annual_report.shared_page.footer": "Generado con {heart} por el equipo de Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} usa {domain}, una de las muchas comunidades que funcionan con Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} se mantuvo a la caza de publicaciones para impulsar, dando visibilidad a otros creadores con una puntería perfecta.",
  "annual_report.summary.archetype.booster.desc_self": "Te mantuviste a la caza de publicaciones para impulsar, amplificando a otros creadores con una puntería perfecta.",
  "annual_report.summary.archetype.booster.name": "El arquero",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Sabemos que {name} estaba ahí fuera, en algún lugar, disfrutando de Mastodon a su manera tranquila.",
  "annual_report.summary.archetype.lurker.desc_self": "Sabemos que estabas ahí fuera, en algún lugar, disfrutando de Mastodon a tu manera, en silencio.",
  "annual_report.summary.archetype.lurker.name": "El estoico",
  "annual_report.summary.archetype.oracle.desc_public": "{name} creó más publicaciones nuevas que respuestas, lo que mantuvo a Mastodon fresco y con visión de futuro.",
  "annual_report.summary.archetype.oracle.desc_self": "Creaste más publicaciones nuevas que respuestas, lo que mantuvo a Mastodon fresco y con visión de futuro.",
  "annual_report.summary.archetype.oracle.name": "El oráculo",
  "annual_report.summary.archetype.pollster.desc_public": "{name} creó más encuestas que otros tipos de publicaciones, lo que despertó la curiosidad en Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Creaste más encuestas que otros tipos de publicaciones, lo que despertó la curiosidad en Mastodon.",
  "annual_report.summary.archetype.pollster.name": "El soñador",
  "annual_report.summary.archetype.replier.desc_public": "{name} respondía con frecuencia a las publicaciones de otras personas, lo que generaba nuevos debates en Mastodon.",
  "annual_report.summary.archetype.replier.desc_self": "Respondías con frecuencia a las publicaciones de otras personas, lo que generaba nuevos debates en Mastodon.",
  "annual_report.summary.archetype.replier.name": "La mariposa",
  "annual_report.summary.archetype.reveal": "Revelar mi arquetipo",
  "annual_report.summary.archetype.reveal_description": "¡Gracias por formar parte de Mastodon! Es hora de descubrir qué arquetipo encarnaste en {year}.",
  "annual_report.summary.archetype.title_public": "El arquetipo de {name}",
  "annual_report.summary.archetype.title_self": "Tu arquetipo",
  "annual_report.summary.close": "Cerrar",
  "annual_report.summary.copy_link": "Copiar enlace",
  "annual_report.summary.followers.new_followers": "{count, plural,one {nuevo seguidor} other {nuevos seguidores}}",
  "annual_report.summary.highlighted_post.boost_count": "Esta publicación fue impulsada {count, plural,one {una vez} other {# veces}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Esta publicación fue marcada como favorita {count, plural,one {una vez} other {# veces}}.",
  "annual_report.summary.highlighted_post.reply_count": "Esta publicación consiguió {count, plural,one {una respuesta} other {# respuestas}}.",
  "annual_report.summary.highlighted_post.title": "Publicación más popular",
  "annual_report.summary.most_used_app.most_used_app": "aplicación más utilizada",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "etiqueta más utilizada",
  "annual_report.summary.most_used_hashtag.used_count": "Incluiste esta etiqueta en {count, plural,one {una publicación} other {# publicaciones}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} incluyó esta etiqueta en {count, plural,one {una publicación} other {# publicaciones}}.",
  "annual_report.summary.new_posts.new_posts": "nuevas publicaciones",
  "annual_report.summary.percentile.text": "<topLabel>Eso te sitúa en el top</topLabel><percentage></percentage><bottomLabel>de usuarios de {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "No se lo diremos a Bernie.",
  "annual_report.summary.share_elsewhere": "Compartir en otro lado",
  "annual_report.summary.share_message": "¡Obtuve el arquetipo {archetype}!",
  "annual_report.summary.share_on_mastodon": "Compartir en Mastodon",
  "attachments_list.unprocessed": "(sin procesar)",
  "audio.hide": "Ocultar audio",
  "block_modal.no_collections": "Ninguno de los dos podrá añadirse mutuamente a las colecciones. Se les eliminará automáticamente de las colecciones existentes del otro, si procede.",
  "block_modal.remote_users_caveat": "Le pediremos al servidor {domain} que respete tu decisión. Sin embargo, el cumplimiento no está garantizado, ya que algunos servidores pueden manejar bloques de forma diferente. Las publicaciones públicas pueden ser todavía visibles para los usuarios no conectados.",
  "block_modal.show_less": "Mostrar menos",
  "block_modal.show_more": "Mostrar más",
  "block_modal.they_cant_mention": "No pueden mencionarse, seguirse ni citarse entre ustedes.",
  "block_modal.they_cant_see_posts": "Ellos no pueden ver tu contenido y tú no verás el de ellos.",
  "block_modal.they_will_know": "Pueden ver que están bloqueados.",
  "block_modal.title": "¿Deseas bloquear al usuario?",
  "block_modal.you_wont_see_mentions": "No verás las publicaciones de otras personas en las que se les mencione.",
  "boost_modal.combo": "Puedes hacer clic en {combo} para saltar este aviso la próxima vez",
  "boost_modal.reblog": "¿Deseas impulsar la publicación?",
  "boost_modal.undo_reblog": "¿Dejar de impulsar la publicación?",
  "bundle_column_error.copy_stacktrace": "Copiar informe de error",
  "bundle_column_error.error.body": "La página solicitada no pudo ser renderizada. Podría deberse a un error en nuestro código o a un problema de compatibilidad con el navegador.",
  "bundle_column_error.error.title": "¡Oh, no!",
  "bundle_column_error.network.body": "Se ha producido un error al intentar cargar esta página. Esto puede deberse a un problema temporal con tu conexión a internet o con este servidor.",
  "bundle_column_error.network.title": "Error de red",
  "bundle_column_error.retry": "Inténtalo de nuevo",
  "bundle_column_error.return": "Volver al inicio",
  "bundle_column_error.routing.body": "No se pudo encontrar la página solicitada. ¿Estás seguro de que la URL en la barra de direcciones es correcta?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Cerrar",
  "bundle_modal_error.message": "Algo ha fallado al cargar esta pantalla.",
  "bundle_modal_error.retry": "Inténtalo de nuevo",
  "callout.dismiss": "Descartar",
  "carousel.current": "<sr>Diapositiva</sr> {current, number} / {max, number}",
  "carousel.slide": "Diapositiva {current, number} de {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} caracteres recomendados",
  "character_counter.required": "{currentLength}/{maxLength} caracteres",
  "closed_registrations.other_server_instructions": "Como Mastodon es descentralizado, puedes crear una cuenta en otro servidor y seguir interactuando con este.",
  "closed_registrations_modal.description": "La creación de una cuenta en {domain} no es posible actualmente, pero ten en cuenta que no necesitas una cuenta específicamente en {domain} para usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Buscar otro servidor",
  "closed_registrations_modal.preamble": "Mastodon es descentralizado, por lo que no importa dónde crees tu cuenta, podrás seguir e interactuar con cualquier persona en este servidor. ¡Incluso puedes alojarlo tú mismo!",
  "closed_registrations_modal.title": "Registrarse en Mastodon",
  "collection.share_modal.share_link_label": "Compartir enlace",
  "collection.share_modal.share_via_post": "Publicar en Mastodon",
  "collection.share_modal.share_via_system": "Compartir con…",
  "collection.share_modal.title": "Compartir la colección",
  "collection.share_modal.title_new": "¡Comparte tu nueva colección!",
  "collection.share_template_other": "Echa un vistazo a esta genial colección:",
  "collection.share_template_own": "Echa un vistazo a mi nueva colección:",
  "collections.account_count": "{count, plural,one {# cuenta} other {# cuentas}}",
  "collections.accounts.empty_description": "Añade hasta {count} cuentas",
  "collections.accounts.empty_editor_title": "No hay nadie en esta colección todavía",
  "collections.accounts.empty_title": "Esta colección está vacía",
  "collections.add_to_collection": "Añadir a {name} a colecciones",
  "collections.block_collection_owner": "Bloquer cuenta",
  "collections.by_account": "de {account_handle}",
  "collections.collection_description": "Descripción",
  "collections.collection_language": "Idioma",
  "collections.collection_language_none": "Ninguno",
  "collections.collection_name": "Nombre",
  "collections.collection_topic": "Tema",
  "collections.confirm_account_removal": "¿Estás seguro/a de que quieres eliminar esta cuenta de esta colección?",
  "collections.content_warning": "Advertencia de contenido",
  "collections.continue": "Continuar",
  "collections.copy_link": "Copiar enlace",
  "collections.copy_link_confirmation": "Se ha copiado el enlace de la colección al portapapeles",
  "collections.create.accounts_title": "¿A quién incluirás en esta colección?",
  "collections.create.basic_details_title": "Detalles básicos",
  "collections.create.steps": "Paso {step}/{total}",
  "collections.create_collection": "Crear colección",
  "collections.delete_collection": "Eliminar colección",
  "collections.description_length_hint": "Limitado a 100 caracteres",
  "collections.detail.author_added_you_on_date": "{author} te agregó el {date}",
  "collections.detail.loading": "Cargando colección…",
  "collections.detail.revoke_inclusion": "Excluirme",
  "collections.detail.sensitive_content": "Contenido sensible",
  "collections.detail.sensitive_note": "Es posible que la descripción y las cuentas no sean aptas para todos las personas.",
  "collections.detail.share": "Compartir esta colección",
  "collections.detail.you_are_in_this_collection": "Apareces en esta colección",
  "collections.edit_details": "Editar detalles",
  "collections.error_loading_collections": "Se ha producido un error al intentar cargar estas colecciones.",
  "collections.hidden_accounts_description": "Has bloqueado o silenciado {count, plural, one {a este usuario} other {a estos usuarios}}",
  "collections.hidden_accounts_link": "{count, plural, one {# cuenta oculta} other {# cuentas ocultas}}",
  "collections.hints.accounts_counter": "{count}/{max} cuentas",
  "collections.last_updated_at": "Última actualización: {date}",
  "collections.list.collections_with_count": "{count, plural,one {# Colección} other {# Colecciones}}",
  "collections.list.created_by_author": "Creada por {name}",
  "collections.list.created_by_you": "Creadas por ti",
  "collections.list.featuring_you": "Con tu partipación",
  "collections.manage_accounts": "Administrar cuentas",
  "collections.mark_as_sensitive": "Marcar como sensible",
  "collections.mark_as_sensitive_hint": "Oculta la descripción y las cuentas de la colección detrás de una advertencia de contenido. El nombre de la colección seguirá siendo visible.",
  "collections.maximum_collection_count_description": "Tu servidor permite la creación de hasta {count} colecciones.",
  "collections.maximum_collection_count_reached": "Has alcanzado el número máximo de colecciones",
  "collections.name_length_hint": "Limitado a 40 caracteres",
  "collections.new_collection": "Nueva colección",
  "collections.pending_accounts.message": "Las cuentas pueden aparecer como pendientes cuando estamos esperando una respuesta del usuario o de su servidor. Solo tú puedes ver las cuentas pendientes.",
  "collections.pending_accounts.title": "¿Por qué estoy viendo cuentas pendientes?",
  "collections.remove_account": "Eliminar",
  "collections.report_collection": "Reportar esta colección",
  "collections.revoke_collection_inclusion": "Excluirme de esta colección",
  "collections.revoke_inclusion.confirmation": "Has sido excluido de \"{collection}\"",
  "collections.revoke_inclusion.error": "Se ha producido un error, por favor, inténtalo de nuevo más tarde.",
  "collections.search_accounts_label": "Buscar una cuenta para añadir",
  "collections.search_accounts_max_reached": "Has añadido el número máximo de cuentas",
  "collections.sensitive": "Sensible",
  "collections.share_short": "Compartir",
  "collections.sort_alphabetical": "Alfabético",
  "collections.sort_by": "Orden:",
  "collections.sort_date_added": "Añadido a fecha",
  "collections.sort_last_active": "Última actividad",
  "collections.sort_most_followers": "Más seguidores",
  "collections.suggestions.can_not_add": "No puede ser añadida",
  "collections.suggestions.can_not_add_desc": "Es posible que estas cuentas hayan optado por no ser descubiertas, o que se encuentren en un servidor que no soporta colecciones.",
  "collections.suggestions.must_follow": "Primero tienes que seguirla",
  "collections.suggestions.must_follow_desc": "Estas cuentas revisan todas las solicitudes de seguimiento. Los seguidores pueden añadirlas a colecciones.",
  "collections.topic_hint": "Añade una etiqueta que ayude a los demás a comprender el tema principal de esta colección.",
  "collections.topic_special_chars_hint": "Los caracteres especiales se eliminarán al guardar",
  "collections.unlisted_collections_description": "No aparecen en tu perfil. Cualquier persona que tenga el enlace puede descubrirlas.",
  "collections.unlisted_collections_with_count": "Colecciones no listadas ({count})",
  "collections.view_collection": "Ver colección",
  "collections.visibility_public": "Pública",
  "collections.visibility_public_hint": "Visible en los resultados de búsqueda y otras áreas donde aparecen recomendaciones.",
  "collections.visibility_title": "Visibilidad",
  "collections.visibility_unlisted": "No listado",
  "collections.visibility_unlisted_hint": "Visible para cualquier persona que tenga el enlace. Oculto en los resultados de búsqueda y las recomendaciones.",
  "column.about": "Acerca de",
  "column.blocks": "Usuarios bloqueados",
  "column.bookmarks": "Marcadores",
  "column.community": "Cronología local",
  "column.create_list": "Crear lista",
  "column.direct": "Menciones privadas",
  "column.directory": "Buscar perfiles",
  "column.domain_blocks": "Dominios ocultados",
  "column.edit_list": "Editar lista",
  "column.favourites": "Favoritos",
  "column.firehose": "Cronologías en vivo",
  "column.firehose_local": "Cronología en vivo para este servidor",
  "column.firehose_singular": "Cronología en vivo",
  "column.follow_requests": "Solicitudes de seguimiento",
  "column.home": "Inicio",
  "column.list_members": "Administrar miembros de la lista",
  "column.lists": "Listas",
  "column.mutes": "Usuarios silenciados",
  "column.notifications": "Notificaciones",
  "column.other_collections": "Colecciones de {name}",
  "column.pins": "Publicaciones fijadas",
  "column.public": "Cronología federada",
  "column.your_collections": "Tus colecciones",
  "column_back_button.label": "Atrás",
  "column_header.hide_settings": "Ocultar configuración",
  "column_header.moveLeft_settings": "Mover columna a la izquierda",
  "column_header.moveRight_settings": "Mover columna a la derecha",
  "column_header.pin": "Fijar",
  "column_header.show_settings": "Mostrar configuración",
  "column_header.unpin": "Dejar de fijar",
  "column_search.cancel": "Cancelar",
  "combobox.close_results": "Cerrar resultados",
  "combobox.loading": "Cargando",
  "combobox.no_results_found": "No hay resultados para esta búsqueda",
  "combobox.open_results": "Abrir resultados",
  "combobox.results_available": "{count, plural,one {# sugerencia} other {# sugerencias}} disponible. Utiliza las teclas de flecha arriba y abajo para navegar. Presiona la tecla Intro para seleccionar.",
  "community.column_settings.local_only": "Solo local",
  "community.column_settings.media_only": "Solo media",
  "community.column_settings.remote_only": "Solo remoto",
  "compose.error.blank_post": "La publicación no puede estar vacía.",
  "compose.language.change": "Cambiar idioma",
  "compose.language.search": "Buscar idiomas...",
  "compose.published.body": "Publicado.",
  "compose.published.open": "Abrir",
  "compose.saved.body": "Publicación guardada.",
  "compose_form.direct_message_warning_learn_more": "Saber más",
  "compose_form.encryption_warning": "Las publicaciones en Mastodon no están cifradas de extremo a extremo. No comparta ninguna información sensible en Mastodon.",
  "compose_form.hashtag_warning": "Esta publicación no será listada bajo ninguna etiqueta dado que no es pública. Solo publicaciones públicas pueden ser buscadas por etiqueta.",
  "compose_form.lock_disclaimer": "Tu cuenta no está {locked}. Todos pueden seguirte para ver tus publicaciones solo para seguidores.",
  "compose_form.lock_disclaimer.lock": "bloqueado",
  "compose_form.placeholder": "¿En qué estás pensando?",
  "compose_form.poll.duration": "Duración de la encuesta",
  "compose_form.poll.multiple": "Selección múltiple",
  "compose_form.poll.option_placeholder": "Opción {number}",
  "compose_form.poll.single": "Selección única",
  "compose_form.poll.switch_to_multiple": "Cambiar la encuesta para permitir múltiples opciones",
  "compose_form.poll.switch_to_single": "Cambiar la encuesta para permitir una única opción",
  "compose_form.poll.type": "Estilo",
  "compose_form.publish": "Publicar",
  "compose_form.reply": "Respuesta",
  "compose_form.save_changes": "Actualizar",
  "compose_form.spoiler.marked": "Quitar advertencia de contenido",
  "compose_form.spoiler.unmarked": "Añadir advertencia de contenido",
  "compose_form.spoiler_placeholder": "Advertencia de contenido (opcional)",
  "confirmation_modal.cancel": "Cancelar",
  "confirmations.block.confirm": "Bloquear",
  "confirmations.delete.confirm": "Eliminar",
  "confirmations.delete.message": "¿Estás seguro de que quieres eliminar esta publicación?",
  "confirmations.delete.title": "¿Deseas eliminar la publicación?",
  "confirmations.delete_collection.confirm": "Eliminar",
  "confirmations.delete_collection.message": "Esta acción no se puede deshacer.",
  "confirmations.delete_collection.title": "¿Eliminar \"{name}\"?",
  "confirmations.delete_list.confirm": "Eliminar",
  "confirmations.delete_list.message": "¿Estás seguro de que quieres eliminar esta lista de forma permanente?",
  "confirmations.delete_list.title": "¿Deseas eliminar la lista?",
  "confirmations.discard_draft.confirm": "Descartar y continuar",
  "confirmations.discard_draft.edit.cancel": "Reanudar la edición",
  "confirmations.discard_draft.edit.message": "La continuación descartará cualquier cambio que hayas realizado en la publicación que estás editando en este momento.",
  "confirmations.discard_draft.edit.title": "¿Deseas descartar los cambios en tu publicación?",
  "confirmations.discard_draft.post.cancel": "Reanudar el borrador",
  "confirmations.discard_draft.post.message": "La continuación descartará la publicación que estás redactando en este momento.",
  "confirmations.discard_draft.post.title": "¿Deseas descartar tu borrador?",
  "confirmations.discard_edit_media.confirm": "Descartar",
  "confirmations.discard_edit_media.message": "Tienes cambios sin guardar en la descripción o vista previa del archivo, ¿deseas descartarlos de cualquier manera?",
  "confirmations.follow_to_list.confirm": "Seguir y agregar a la lista",
  "confirmations.follow_to_list.message": "Tienes que seguir a {name} para añadirlo a una lista.",
  "confirmations.follow_to_list.title": "¿Seguir a usuario?",
  "confirmations.hide_featured_tab.confirm": "Ocultar pestaña",
  "confirmations.hide_featured_tab.intro": "Puedes cambiar esto en cualquier momento en <i>Editar perfil > Configuración de la pestaña Perfil</i>.",
  "confirmations.hide_featured_tab.message": "Esto ocultará la pestaña para los usuarios de {serverName} y otros servidores que ejecuten la última versión de Mastodon. La visualización puede variar en otros casos.",
  "confirmations.hide_featured_tab.title": "¿Deseas ocultar la pestaña \"Destacado\"?",
  "confirmations.logout.confirm": "Cerrar sesión",
  "confirmations.logout.message": "¿Estás seguro de que quieres cerrar la sesión?",
  "confirmations.logout.title": "¿Deseas cerrar sesión?",
  "confirmations.missing_alt_text.confirm": "Añadir texto alternativo",
  "confirmations.missing_alt_text.message": "Tu publicación contiene contenido multimedia sin texto alternativo. Añadir descripciones ayuda a que tu contenido sea accesible para más personas.",
  "confirmations.missing_alt_text.secondary": "Publicar de todas maneras",
  "confirmations.missing_alt_text.title": "¿Añadir texto alternativo?",
  "confirmations.mute.confirm": "Silenciar",
  "confirmations.private_quote_notify.cancel": "Seguir editando",
  "confirmations.private_quote_notify.confirm": "Publicar",
  "confirmations.private_quote_notify.do_not_show_again": "No mostrar este mensaje de nuevo",
  "confirmations.private_quote_notify.message": "La persona a la que citas y otras mencionadas recibirán una notificación y podrán ver tu publicación, aunque no te sigan.",
  "confirmations.private_quote_notify.title": "¿Compartir con seguidores y usuarios mencionados?",
  "confirmations.quiet_post_quote_info.dismiss": "No me lo recuerdes otra vez",
  "confirmations.quiet_post_quote_info.got_it": "Entendido",
  "confirmations.quiet_post_quote_info.message": "Al citar una publicación pública discreta, tu publicación se ocultará de las cronologías de tendencias.",
  "confirmations.quiet_post_quote_info.title": "Citar publicaciones públicas discretas",
  "confirmations.redraft.confirm": "Eliminar y volver a redactar",
  "confirmations.redraft.message": "¿Estás seguro de que quieres eliminar esta publicación y volver a redactarla? Se perderán tanto los «Me gusta» como los impulsos, y las respuestas a la publicación original quedarán sin referencia.",
  "confirmations.redraft.title": "¿Deseas eliminar y volver a redactar la publicación?",
  "confirmations.remove_from_followers.confirm": "Eliminar seguidor",
  "confirmations.remove_from_followers.message": "{name} dejará de seguirte. ¿Estás seguro de que quieres continuar?",
  "confirmations.remove_from_followers.title": "¿Eliminar seguidor?",
  "confirmations.revoke_collection_inclusion.confirm": "Excluirme",
  "confirmations.revoke_collection_inclusion.message": "El editor no podrá volver a añadirte a esta colección hasta dentro de 24 horas. Para evitar que te añada a colecciones de forma permanente, puedes bloquearlo.",
  "confirmations.revoke_collection_inclusion.title": "¿Deseas excluirte de esta colección?",
  "confirmations.revoke_quote.confirm": "Eliminar publicación",
  "confirmations.revoke_quote.message": "Esta acción no se puede deshacer.",
  "confirmations.revoke_quote.title": "¿Deseas eliminar la publicación?",
  "confirmations.unblock.confirm": "Desbloquear",
  "confirmations.unblock.title": "¿Desbloquear a {name}?",
  "confirmations.unfollow.confirm": "Dejar de seguir",
  "confirmations.unfollow.title": "¿Dejar de seguir a {name}?",
  "confirmations.withdraw_request.confirm": "Cancelar solicitud",
  "confirmations.withdraw_request.title": "¿Cancelar solicitud para seguir a {name}?",
  "content_warning.hide": "Ocultar publicación",
  "content_warning.show": "Mostrar de todos modos",
  "content_warning.show_more": "Mostrar más",
  "content_warning.show_short": "Mostrar",
  "conversation.delete": "Eliminar conversación",
  "conversation.mark_as_read": "Marcar como leído",
  "conversation.open": "Ver conversación",
  "conversation.with": "Con {names}",
  "copy_icon_button.copied": "Copiado al portapapeles",
  "copy_icon_button.copy_this_text": "Copiar enlace al portapapeles",
  "copypaste.copied": "Copiado",
  "copypaste.copy_to_clipboard": "Copiar al portapapeles",
  "custom_homepage.about": "Acerca de",
  "custom_homepage.about_this_server": "Acerca de este servidor",
  "custom_homepage.administered_by": "Administrado por",
  "custom_homepage.contact": "Contacto:",
  "custom_homepage.latest_activity": "Actividad más reciente",
  "custom_homepage.these_are_the_latest_posts": "Estas son las últimas 40 publicaciones de las cuentas de este servidor.",
  "directory.federated": "Desde el fediverso conocido",
  "directory.local": "Sólo de {domain}",
  "directory.new_arrivals": "Recién llegados",
  "directory.recently_active": "Recientemente activo",
  "disabled_account_banner.account_settings": "Configuración de la cuenta",
  "disabled_account_banner.text": "Tu cuenta {disabledAccount} está actualmente deshabilitada.",
  "dismissable_banner.community_timeline": "Estas son las publicaciones públicas más recientes de las personas cuyas cuentas están alojadas en {domain}.",
  "dismissable_banner.dismiss": "Descartar",
  "dismissable_banner.public_timeline": "Estas son las publicaciones más recientes de las personas del fediverso a las que sigue la gente de {domain}.",
  "domain_block_modal.block": "Bloquear servidor",
  "domain_block_modal.block_account_instead": "Bloquear @{name} en su lugar",
  "domain_block_modal.they_can_interact_with_old_posts": "Las personas de este servidor pueden interactuar con tus publicaciones antiguas.",
  "domain_block_modal.they_cant_follow": "Nadie de este servidor puede seguirte.",
  "domain_block_modal.they_wont_know": "No sabrán que han sido bloqueados.",
  "domain_block_modal.title": "¿Deseas bloquear el dominio?",
  "domain_block_modal.you_will_lose_num_followers": "Vas a perder {followersCount, plural, one {{followersCountDisplay} seguidor} other {{followersCountDisplay} seguidores}} y {followingCount, plural, one {{followingCountDisplay} persona a la que sigues} other {{followingCountDisplay} personas a las que sigas}}.",
  "domain_block_modal.you_will_lose_relationships": "Perderás todos los seguidores y las personas que sigues de este servidor.",
  "domain_block_modal.you_wont_see_posts": "No verás publicaciones ni notificaciones de usuarios en este servidor.",
  "dropdown.empty": "Elige una opción",
  "email_subscriptions.email": "Correo electrónico",
  "email_subscriptions.form.action": "Suscribirse",
  "email_subscriptions.form.bottom": "Recibe publicaciones en tu bandeja de entrada sin necesidad de crear una cuenta de Mastodon. Puedes darte de baja en cualquier momento. Para obtener más información, consulta la <a>Política de privacidad</a>.",
  "email_subscriptions.form.title": "Suscríbete para recibir actualizaciones por correo electrónico de {name}",
  "email_subscriptions.submitted.lead": "Revisa tu bandeja de entrada para encontrar el correo electrónico que te permitirá completar tu suscripción a las actualizaciones por correo electrónico.",
  "email_subscriptions.submitted.title": "Un paso más",
  "email_subscriptions.validation.email.blocked": "Proveedor de correo electrónico bloqueado",
  "email_subscriptions.validation.email.invalid": "Dirección de correo electrónico no válida",
  "embed.instructions": "Añade esta publicación a tu sitio web con el siguiente código.",
  "embed.preview": "Así es como se verá:",
  "emoji_button.activity": "Actividad",
  "emoji_button.clear": "Eliminar",
  "emoji_button.custom": "Personalizado",
  "emoji_button.flags": "Marcas",
  "emoji_button.food": "Comida y bebida",
  "emoji_button.label": "Insertar emoji",
  "emoji_button.nature": "Naturaleza",
  "emoji_button.not_found": "No se han encontrado emojis que coincidan",
  "emoji_button.objects": "Objetos",
  "emoji_button.people": "Gente",
  "emoji_button.recent": "Usados frecuentemente",
  "emoji_button.search": "Buscar...",
  "emoji_button.search_results": "Resultados de búsqueda",
  "emoji_button.symbols": "Símbolos",
  "emoji_button.travel": "Viajes y lugares",
  "empty_column.account_featured.other": "{acct} no ha destacado nada todavía.",
  "empty_column.account_featured_self.no_collections_button": "Crear una colección",
  "empty_column.account_featured_self.no_collections_hide_tab": "Ocultar esta pestaña",
  "empty_column.account_featured_self.showcase_accounts": "Destaca tus cuentas favoritas",
  "empty_column.account_featured_self.showcase_accounts_desc": "Las colecciones son listas de cuentas seleccionadas que ayudan a otros a descubrir más del Fediverso.",
  "empty_column.account_featured_unknown.other": "Esta cuenta no ha destacado nada todavía.",
  "empty_column.account_hides_collections": "Este usuario ha elegido no hacer disponible esta información",
  "empty_column.account_suspended": "Cuenta suspendida",
  "empty_column.account_timeline": "¡No hay publicaciones aquí!",
  "empty_column.account_unavailable": "Perfil no disponible",
  "empty_column.blocks": "Aún no has bloqueado a ningún usuario.",
  "empty_column.bookmarked_statuses": "Aún no tienes ninguna publicación guardada como marcador. Cuando guardes una, se mostrará aquí.",
  "empty_column.collections": "{acct} todavía no ha creado ninguna colección.",
  "empty_column.collections.featured_in": "Aún no te han añadido a ninguna colección.",
  "empty_column.collections.featured_in_undiscoverable": "Para que los usuarios puedan añadirte a sus colecciones, debes habilitar la opción de aparecer en las experiencias de descubrimiento desde <link>Preferencias > Privacidad y alcance</link>",
  "empty_column.collections_self": "Aún no has creado ninguna colección.",
  "empty_column.community": "La cronología local está vacía. ¡Escribe algo públicamente para ponerla en marcha!",
  "empty_column.direct": "Aún no tienes ninguna mención privada. Cuando envíes o recibas una, aparecerá aquí.",
  "empty_column.disabled_feed": "Esta cronología fue desactivada por los administradores de tu servidor.",
  "empty_column.domain_blocks": "Todavía no hay dominios ocultos.",
  "empty_column.explore_statuses": "Nada es tendencia en este momento. ¡Revisa más tarde!",
  "empty_column.favourited_statuses": "Todavía no tienes publicaciones favoritas. Cuando le des favorito a una publicación se mostrarán acá.",
  "empty_column.favourites": "Todavía nadie marcó como favorito esta publicación. Cuando alguien lo haga, se mostrará aquí.",
  "empty_column.follow_requests": "No tienes ninguna petición de seguidor. Cuando recibas una, se mostrará aquí.",
  "empty_column.followed_tags": "No estás siguiendo ninguna etiqueta todavía. Cuando lo hagas, aparecerá aquí.",
  "empty_column.hashtag": "No hay nada en esta etiqueta aún.",
  "empty_column.home": "¡Tu cronología está vacía! Sigue a más gente para llenarla.",
  "empty_column.list": "Aún no hay nada en esta lista. Cuando los miembros de esta lista publiquen nuevos contenidos, aparecerán aquí.",
  "empty_column.mutes": "Aún no has silenciado a ningún usuario.",
  "empty_column.notification_requests": "¡Todo limpio! No hay nada aquí. Cuando recibas nuevas notificaciones, aparecerán aquí conforme a tu configuración.",
  "empty_column.notifications": "No tienes ninguna notificación aún. Interactúa con otros para empezar una conversación.",
  "empty_column.public": "¡Aquí no hay nada! Escribe algo públicamente o sigue manualmente a usuarios de otros servidores para llenarlo",
  "empty_state.no_results": "No hay resultados",
  "error.no_hashtag_feed_access": "Únete o inicia sesión para ver y seguir esta etiqueta.",
  "error.unexpected_crash.explanation": "Debido a un error en nuestro código o a un problema de compatibilidad con el navegador, esta página no se ha podido mostrar correctamente.",
  "error.unexpected_crash.explanation_addons": "No se pudo mostrar correctamente esta página. Este error probablemente fue causado por un complemento del navegador web o por herramientas de traducción automática.",
  "error.unexpected_crash.next_steps": "Intenta actualizar la página. Si eso no ayuda, es posible que puedas usar Mastodon a través de otro navegador o aplicación nativa.",
  "error.unexpected_crash.next_steps_addons": "Intenta deshabilitarlos y recarga la página. Si eso no ayuda, podrías usar Mastodon a través de un navegador web diferente o aplicación nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar el seguimiento de pila en el portapapeles",
  "errors.unexpected_crash.report_issue": "Informar problema",
  "explore.suggested_follows": "Personas",
  "explore.title": "En tendencia",
  "explore.trending_links": "Noticias",
  "explore.trending_statuses": "Publicaciones",
  "explore.trending_tags": "Etiquetas",
  "featured_carousel.current": "<sr>Publicación</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural,one {Publicación fijada}other {Publicaciones fijadas}}",
  "featured_carousel.slide": "Publicación {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Últimamente has publicado sobre {items}. ¿Deseas añadirlo como etiqueta destacada?",
  "featured_tags.suggestions.add": "Añadir",
  "featured_tags.suggestions.added": "Controla tus etiquetas destacadas en cualquier momento en <link>Editar perfil > Etiquetas destacadas</link>.",
  "featured_tags.suggestions.dismiss": "No, gracias",
  "filter_modal.added.context_mismatch_explanation": "Esta categoría de filtro no se aplica al contexto en el que has accedido a esta publicación. Si deseas que la publicación también se filtre en este contexto, tendrás que editar el filtro.",
  "filter_modal.added.context_mismatch_title": "¡El contexto no coincide!",
  "filter_modal.added.expired_explanation": "Esta categoría de filtro ha caducado; deberás cambiar la fecha de caducidad para que se aplique.",
  "filter_modal.added.expired_title": "¡Filtro expirado!",
  "filter_modal.added.review_and_configure": "Para revisar y configurar esta categoría de filtros, vaya a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Configuración de filtros",
  "filter_modal.added.settings_link": "página de configuración",
  "filter_modal.added.short_explanation": "Esta publicación ha sido añadida a la siguiente categoría de filtros: {title}.",
  "filter_modal.added.title": "¡Filtro añadido!",
  "filter_modal.select_filter.context_mismatch": "no se aplica a este contexto",
  "filter_modal.select_filter.expired": "expirado",
  "filter_modal.select_filter.prompt_new": "Nueva categoría: {name}",
  "filter_modal.select_filter.search": "Buscar o crear",
  "filter_modal.select_filter.subtitle": "Usar una categoría existente o crear una nueva",
  "filter_modal.select_filter.title": "Filtrar esta publicación",
  "filter_modal.title.status": "Filtrar una publicación",
  "filter_warning.matches_filter": "Coincide con el filtro “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "De {count, plural, =0 {nadie} one {una persona} other {# people}} que puede que tú conozcas",
  "filtered_notifications_banner.title": "Notificaciones filtradas",
  "firehose.all": "Todas",
  "firehose.local": "Este servidor",
  "firehose.remote": "Otros servidores",
  "follow_request.authorize": "Autorizar",
  "follow_request.reject": "Rechazar",
  "follow_requests.unlocked_explanation": "A pesar de que tu cuenta no es privada, el personal de {domain} ha pensado que quizás deberías revisar manualmente las solicitudes de seguimiento de estas cuentas.",
  "follow_suggestions.curated_suggestion": "Recomendaciones del equipo",
  "follow_suggestions.dismiss": "No mostrar de nuevo",
  "follow_suggestions.featured_longer": "Escogidos por el equipo de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popular entre las personas a las que sigues",
  "follow_suggestions.hints.featured": "Este perfil ha sido seleccionado a mano por el equipo de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Este perfil es popular entre las personas que sigues.",
  "follow_suggestions.hints.most_followed": "Este perfil es uno de los más seguidos en {domain}.",
  "follow_suggestions.hints.most_interactions": "Este perfil ha estado recibiendo mucha atención en {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Este perfil es similar a los perfiles que has seguido recientemente.",
  "follow_suggestions.personalized_suggestion": "Sugerencia personalizada",
  "follow_suggestions.popular_suggestion": "Sugerencia popular",
  "follow_suggestions.popular_suggestion_longer": "Popular en {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Similares a los perfiles que has seguido recientemente",
  "follow_suggestions.view_all": "Ver todo",
  "follow_suggestions.who_to_follow": "Recomendamos seguir",
  "followed_tags": "Etiquetas seguidas",
  "followers.hide_other_followers": "Este usuario ha elegido no hacer visibles a sus otros seguidores",
  "followers.title": "Siguiendo a {name}",
  "following.hide_other_following": "Este usuario ha elegido no hacer visible el resto de personas a las que sigue",
  "following.title": "Seguido por {name}",
  "footer.about": "Acerca de",
  "footer.about_mastodon": "Acerca de Mastodon",
  "footer.about_server": "Acerca de {domain}",
  "footer.about_this_server": "Sobre nosotros",
  "footer.directory": "Directorio de perfiles",
  "footer.get_app": "Obtener la aplicación",
  "footer.keyboard_shortcuts": "Atajos de teclado",
  "footer.privacy_policy": "Política de privacidad",
  "footer.source_code": "Ver código fuente",
  "footer.status": "Estado",
  "footer.terms_of_service": "Condiciones del servicio",
  "form_error.blank": "El campo no puede quedar en blanco.",
  "form_field.optional": "(opcional)",
  "getting_started.heading": "Primeros pasos",
  "hashtag.admin_moderation": "Abrir interfaz de moderación para #{name}",
  "hashtag.browse": "Explorar publicaciones en #{hashtag}",
  "hashtag.browse_from_account": "Explorar publicaciones de @{name} en #{hashtag}",
  "hashtag.column_header.tag_mode.all": "y {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sin {additional}",
  "hashtag.column_settings.select.no_options_message": "No se encontraron sugerencias",
  "hashtag.column_settings.select.placeholder": "Introducir etiquetas…",
  "hashtag.column_settings.tag_mode.all": "Todos estos",
  "hashtag.column_settings.tag_mode.any": "Cualquiera de estas",
  "hashtag.column_settings.tag_mode.none": "Ninguna de estas",
  "hashtag.column_settings.tag_toggle": "Incluye etiquetas adicionales para esta columna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participante} other {{counter} participantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} publicación} other {{counter} publicaciones}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} publicación} other {{counter} publicaciones}} hoy",
  "hashtag.feature": "Destacar en el perfil",
  "hashtag.follow": "Seguir etiqueta",
  "hashtag.mute": "Silenciar #{hashtag}",
  "hashtag.unfeature": "No destacar en el perfil",
  "hashtag.unfollow": "Dejar de seguir etiqueta",
  "hashtags.and_other": "…y {count, plural, other {# más}}",
  "hints.profiles.followers_may_be_missing": "Puede que no se muestren todos los seguidores de este perfil.",
  "hints.profiles.follows_may_be_missing": "Puede que no se muestren todas las cuentas seguidas por este perfil.",
  "hints.profiles.posts_may_be_missing": "Puede que no se muestren todas las publicaciones de este perfil.",
  "hints.profiles.see_more_followers": "Ver más seguidores en {domain}",
  "hints.profiles.see_more_follows": "Ver más perfiles seguidos en {domain}",
  "hints.profiles.see_more_posts": "Ver más publicaciones en {domain}",
  "home.column_settings.show_quotes": "Mostrar citas",
  "home.column_settings.show_reblogs": "Mostrar impulsos",
  "home.column_settings.show_replies": "Mostrar respuestas",
  "home.hide_announcements": "Ocultar anuncios",
  "home.pending_critical_update.body": "¡Por favor actualiza tu servidor Mastodon lo antes posible!",
  "home.pending_critical_update.link": "Ver actualizaciones",
  "home.pending_critical_update.title": "¡Actualización de seguridad crítica disponible!",
  "home.show_announcements": "Mostrar anuncios",
  "ignore_notifications_modal.bots_title": "¿Ignorar las notificaciones de los bots?",
  "ignore_notifications_modal.disclaimer": "Mastodon no puede informar a los usuarios que has ignorado sus notificaciones. Ignorar notificaciones no impedirá que se sigan enviando los mensajes.",
  "ignore_notifications_modal.filter_instead": "Filtrar en su lugar",
  "ignore_notifications_modal.filter_to_act_users": "Aún podrás aceptar, rechazar o reportar usuarios",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrar ayuda a evitar confusiones potenciales",
  "ignore_notifications_modal.filter_to_review_separately": "Puedes revisar las notificaciones filtradas por separado",
  "ignore_notifications_modal.ignore": "Ignorar notificaciones",
  "ignore_notifications_modal.limited_accounts_title": "¿Ignorar notificaciones de cuentas moderadas?",
  "ignore_notifications_modal.new_accounts_title": "¿Ignorar notificaciones de cuentas nuevas?",
  "ignore_notifications_modal.not_followers_title": "¿Ignorar notificaciones de personas que no te siguen?",
  "ignore_notifications_modal.not_following_title": "¿Ignorar notificaciones de personas a las que no sigues?",
  "ignore_notifications_modal.private_mentions_title": "¿Ignorar las notificaciones de menciones privadas no solicitadas?",
  "info_button.label": "Ayuda",
  "info_button.what_is_alt_text": "<h1>¿Qué es el texto alternativo?</h1> <p>El texto alternativo ofrece descripciones de las imágenes para individuos con dificultades visuales, conexiones de bajo ancho de banda o que buscan un contexto adicional.</p> <p>Puedes mejorar la accesibilidad y la comprensión para todos redactando un texto alternativo claro, breve y objetivo.</p> <ul><li>Captura los elementos clave.</li><li>Resume el texto en imágenes.</li><li>Utiliza una estructura de oraciones estándar.</li><li>Evita la información repetitiva.</li><li>Enfócate en las tendencias y conclusiones principales de los elementos visuales complejos (como gráficos o mapas).</li></ul>",
  "interaction_modal.action": "Para interactuar con la publicación de {name}, debes iniciar sesión en tu cuenta en cualquier servidor Mastodon que utilices.",
  "interaction_modal.action_follow": "Para seguir a {name}, debes iniciar sesión en tu cuenta en el servidor de Mastodon que utilices.",
  "interaction_modal.go": "Ir",
  "interaction_modal.no_account_yet": "¿Aún no tienes una cuenta?",
  "interaction_modal.on_another_server": "En un servidor diferente",
  "interaction_modal.on_this_server": "En este servidor",
  "interaction_modal.title": "Inicia sesión para continuar",
  "interaction_modal.username_prompt": "Por ejemplo: {example}",
  "intervals.full.days": "{number, plural, one {# día} other {# días}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horas}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minutos}}",
  "keyboard_shortcuts.back": "Volver atrás",
  "keyboard_shortcuts.blocked": "Abrir la lista de usuarios bloqueados",
  "keyboard_shortcuts.boost": "Impulsar publicación",
  "keyboard_shortcuts.column": "Enfocar columna",
  "keyboard_shortcuts.compose": "Enfocar el área de texto de redacción",
  "keyboard_shortcuts.description": "Descripción",
  "keyboard_shortcuts.direct": "Abrir columna de menciones privadas",
  "keyboard_shortcuts.down": "Descender en la lista",
  "keyboard_shortcuts.enter": "Abrir publicación",
  "keyboard_shortcuts.explore": "Abrir tendencias",
  "keyboard_shortcuts.favourite": "Marcar como favorita la publicación",
  "keyboard_shortcuts.favourites": "Abrir lista de favoritos",
  "keyboard_shortcuts.federated": "Abrir cronología federada",
  "keyboard_shortcuts.heading": "Atajos de teclado",
  "keyboard_shortcuts.home": "Abrir cronología principal",
  "keyboard_shortcuts.hotkey": "Tecla de acceso rápido",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Espacio",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Escape",
  "keyboard_shortcuts.keys.page_down": "Re Pág",
  "keyboard_shortcuts.keys.page_up": "Av Pág",
  "keyboard_shortcuts.legend": "Mostrar esta leyenda",
  "keyboard_shortcuts.load_more": "Enfoque en el botón \"Cargar más\"",
  "keyboard_shortcuts.local": "Abrir cronología local",
  "keyboard_shortcuts.mention": "Mencionar al autor",
  "keyboard_shortcuts.muted": "Abrir la lista de usuarios silenciados",
  "keyboard_shortcuts.my_profile": "Abrir tu perfil",
  "keyboard_shortcuts.notifications": "Abrir la columna de notificaciones",
  "keyboard_shortcuts.open_media": "Abrir multimedia",
  "keyboard_shortcuts.pinned": "Abrir la lista de publicaciones fijadas",
  "keyboard_shortcuts.profile": "Abrir perfil del autor",
  "keyboard_shortcuts.quote": "Citar publicación",
  "keyboard_shortcuts.reply": "Responder a la publicación",
  "keyboard_shortcuts.requests": "Abrir lista de solicitudes de seguimiento",
  "keyboard_shortcuts.search": "Enfocar la barra de búsqueda",
  "keyboard_shortcuts.spoilers": "Mostrar/ocultar el campo AC",
  "keyboard_shortcuts.start": "Abrir la columna “empezar”",
  "keyboard_shortcuts.toggle_hidden": "Mostrar/ocultar texto detrás de AC",
  "keyboard_shortcuts.toggle_sensitivity": "Mostrar/ocultar multimedia",
  "keyboard_shortcuts.toot": "Comenzar una nueva publicación",
  "keyboard_shortcuts.top": "Mover al principio de la lista",
  "keyboard_shortcuts.translate": "Traducir una publicación",
  "keyboard_shortcuts.unfocus": "Desenfocar área de redacción/búsqueda",
  "keyboard_shortcuts.up": "Ascender en la lista",
  "learn_more_link.got_it": "Entendido",
  "learn_more_link.learn_more": "Más información",
  "lightbox.close": "Cerrar",
  "lightbox.next": "Siguiente",
  "lightbox.previous": "Anterior",
  "lightbox.zoom_in": "Ampliar al tamaño real",
  "lightbox.zoom_out": "Ampliar para ajustar",
  "limited_account_hint.action": "Mostrar perfil de todos modos",
  "limited_account_hint.title": "Este perfil o servidor ha sido ocultado por los moderadores de {domain}.",
  "link_preview.author": "Por {name}",
  "link_preview.more_from_author": "Más de {name}",
  "link_preview.shares": "{count, plural, one {{counter} publicación} other {{counter} publicaciones}}",
  "lists.add_member": "Añadir",
  "lists.add_to_list": "Añadir a la lista",
  "lists.add_to_lists": "Añadir {name} a listas",
  "lists.create": "Crear",
  "lists.create_a_list_to_organize": "Crea una nueva lista para organizar tu página de inicio",
  "lists.create_list": "Crear lista",
  "lists.delete": "Eliminar lista",
  "lists.done": "Hecho",
  "lists.edit": "Editar lista",
  "lists.exclusive": "Ocultar miembros en Inicio",
  "lists.exclusive_hint": "Si alguien aparece en esta lista, ocúltalo en tu página de inicio para evitar ver sus publicaciones dos veces.",
  "lists.find_users_to_add": "Buscar usuarios para añadir",
  "lists.list_members_count": "{count, plural,one {# miembro} other {# miembros}}",
  "lists.list_name": "Nombre de la lista",
  "lists.new_list_name": "Nombre de la nueva lista",
  "lists.no_lists_yet": "No hay listas todavía.",
  "lists.no_members_yet": "No hay miembros todavía.",
  "lists.no_results_found": "No se han encontrado resultados.",
  "lists.remove_member": "Eliminar",
  "lists.replies_policy.followed": "Cualquier usuario seguido",
  "lists.replies_policy.list": "Miembros de la lista",
  "lists.replies_policy.none": "Nadie",
  "lists.save": "Guardar",
  "lists.search": "Buscar",
  "lists.show_replies_to": "Incluir respuestas de miembros de la lista a",
  "load_pending": "{count, plural, one {# nuevo elemento} other {# nuevos elementos}}",
  "loading_indicator.label": "Cargando…",
  "media_gallery.hide": "Ocultar",
  "moved_to_account_banner.text": "Tu cuenta {disabledAccount} está actualmente deshabilitada porque te has mudado a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Ocultar de las notificaciones",
  "mute_modal.hide_options": "Ocultar opciones",
  "mute_modal.indefinite": "Hasta que deje de silenciarlos",
  "mute_modal.show_options": "Mostrar opciones",
  "mute_modal.they_can_mention_and_follow": "Pueden mencionarte y seguirte, pero no verás nada de ellos.",
  "mute_modal.they_wont_know": "No sabrán que han sido silenciados.",
  "mute_modal.title": "¿Deseas silenciar el usuario?",
  "mute_modal.you_wont_see_mentions": "No verás publicaciones que los mencionen.",
  "mute_modal.you_wont_see_posts": "Todavía pueden ver tus publicaciones, pero tú no verás las de ellos.",
  "navigation_bar.about": "Acerca de",
  "navigation_bar.account_settings": "Contraseña y seguridad",
  "navigation_bar.administration": "Administración",
  "navigation_bar.advanced_interface": "Abrir en interfaz web avanzada",
  "navigation_bar.automated_deletion": "Eliminación automática de publicaciones",
  "navigation_bar.blocks": "Usuarios bloqueados",
  "navigation_bar.bookmarks": "Marcadores",
  "navigation_bar.collections": "Colecciones",
  "navigation_bar.direct": "Menciones privadas",
  "navigation_bar.domain_blocks": "Dominios ocultos",
  "navigation_bar.favourites": "Favoritos",
  "navigation_bar.filters": "Palabras silenciadas",
  "navigation_bar.follow_requests": "Solicitudes para seguirte",
  "navigation_bar.followed_tags": "Etiquetas seguidas",
  "navigation_bar.follows_and_followers": "Siguiendo y seguidores",
  "navigation_bar.import_export": "Importar y exportar",
  "navigation_bar.lists": "Listas",
  "navigation_bar.live_feed_local": "Cronología local",
  "navigation_bar.live_feed_public": "Cronología pública",
  "navigation_bar.logout": "Cerrar sesión",
  "navigation_bar.main": "Principal",
  "navigation_bar.moderation": "Moderación",
  "navigation_bar.more": "Más",
  "navigation_bar.mutes": "Usuarios silenciados",
  "navigation_bar.opened_in_classic_interface": "Publicaciones, cuentas y otras páginas específicas se abren por defecto en la interfaz web clásica.",
  "navigation_bar.preferences": "Preferencias",
  "navigation_bar.privacy_and_reach": "Privacidad y alcance",
  "navigation_bar.search": "Buscar",
  "navigation_bar.search_trends": "Búsqueda / Tendencia",
  "navigation_panel.collapse_followed_tags": "Minimizar menú de etiquetas seguidas",
  "navigation_panel.collapse_lists": "Contraer el menú de la lista",
  "navigation_panel.expand_followed_tags": "Expandir menú de etiquetas seguidas",
  "navigation_panel.expand_lists": "Expandir menú de lista",
  "not_signed_in_indicator.not_signed_in": "Necesitas iniciar sesión para acceder a este recurso.",
  "notification.added_to_collection": "{name} te añadió a una colección",
  "notification.admin.report": "{name} denunció a {target}",
  "notification.admin.report_account": "{name} reportó {count, plural, one {una publicación} other {# publicaciones}} de {target} por {category}",
  "notification.admin.report_account_other": "{name} reportó {count, plural, one {una publicación} other {# publicaciones}} de {target}",
  "notification.admin.report_statuses": "{name} reportó {target} por {category}",
  "notification.admin.report_statuses_other": "{name} reportó {target}",
  "notification.admin.sign_up": "{name} se registró",
  "notification.admin.sign_up.name_and_others": "{name} y {count, plural, one {# otro} other {# otros}} se registraron",
  "notification.annual_report.message": "¡Tu #Wrapstodon {year} te espera! ¡Desvela los momentos más destacados y memorables de tu año en Mastodon!",
  "notification.annual_report.view": "Ver #Wrapstodon",
  "notification.collection_update": "{name} editó una colección en la que estás",
  "notification.favourite": "{name} marcó como favorita tu publicación",
  "notification.favourite.name_and_others_with_link": "{name} y <a>{count, plural, one {# otro} other {# otros}}</a> marcaron tu publicación como favorita",
  "notification.favourite_pm": "{name} marcó como favorito tu mención privada",
  "notification.favourite_pm.name_and_others_with_link": "{name} y <a>{count, plural, one {# otro} other {# otros}}</a> marcaron como favorito tu mención privada",
  "notification.follow": "{name} te empezó a seguir",
  "notification.follow.name_and_others": "{name} y <a>{count, plural, one {# otro} other {# otros}}</a> te han seguido",
  "notification.follow_request": "{name} ha solicitado seguirte",
  "notification.follow_request.name_and_others": "{name} y {count, plural, one {# otro} other {# otros}} han solicitado seguirte",
  "notification.label.mention": "Mención",
  "notification.label.private_mention": "Mención privada",
  "notification.label.private_reply": "Respuesta privada",
  "notification.label.quote": "{name} citó tu publicación",
  "notification.label.reply": "Respuesta",
  "notification.mention": "Mención",
  "notification.mentioned_you": "{name} te mencionó",
  "notification.moderation-warning.learn_more": "Saber más",
  "notification.moderation_warning": "Has recibido una advertencia de moderación",
  "notification.moderation_warning.action_delete_statuses": "Se han eliminado algunas de tus publicaciones.",
  "notification.moderation_warning.action_disable": "Tu cuenta ha sido desactivada.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Se han marcado como sensibles algunas de tus publicaciones.",
  "notification.moderation_warning.action_none": "Tu cuenta ha recibido una advertencia de moderación.",
  "notification.moderation_warning.action_sensitive": "De ahora en adelante, todas tus publicaciones se marcarán como sensibles.",
  "notification.moderation_warning.action_silence": "Tu cuenta ha sido limitada.",
  "notification.moderation_warning.action_suspend": "Tu cuenta ha sido suspendida.",
  "notification.own_poll": "Tu encuesta ha terminado",
  "notification.poll": "Una encuesta en la que has votado ha terminado",
  "notification.quoted_update": "{name} editó una publicación que has citado",
  "notification.reblog": "{name} ha impulsado tu publicación",
  "notification.reblog.name_and_others_with_link": "{name} y <a>{count, plural, one {# otro} other {# otros}}</a> impulsaron tu publicación",
  "notification.relationships_severance_event": "Conexiones perdidas con {name}",
  "notification.relationships_severance_event.account_suspension": "Un administrador de {from} ha suspendido {target}, lo que significa que ya no puedes recibir actualizaciones de sus cuentas o interactuar con ellas.",
  "notification.relationships_severance_event.domain_block": "Un administrador de {from} ha bloqueado {target}, incluyendo {followersCount} de tus seguidores y {followingCount, plural, one {# cuenta} other {# cuentas}} que sigues.",
  "notification.relationships_severance_event.learn_more": "Más información",
  "notification.relationships_severance_event.user_domain_block": "Has bloqueado {target}, eliminando {followersCount} de tus seguidores y {followingCount, plural, one {# cuenta} other {# cuentas}} que sigues.",
  "notification.status": "{name} acaba de publicar",
  "notification.update": "{name} editó una publicación",
  "notification_requests.accept": "Aceptar",
  "notification_requests.accept_multiple": "{count, plural, one {Aceptar # solicitud…} other {Aceptar # solicitudes…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Solicitud aceptada} other {Solicitudes aceptadas}}",
  "notification_requests.confirm_accept_multiple.message": "Estás por aceptar {count, plural, one {una solicitud de notificación} other {# solicitudes de notificación}}. ¿Estás seguro de que quieres continuar?",
  "notification_requests.confirm_accept_multiple.title": "¿Deseas aceptar las solicitudes de notificación?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Solicitud descartada} other {Solicitudes descartadas}}",
  "notification_requests.confirm_dismiss_multiple.message": "Estás por descartar {count, plural, one {una solicitud de notificación} other {# solicitudes de notificación}}. No serás capaz de acceder fácilmente a {count, plural, one {ella} other {ellas}} de nuevo. ¿Estás seguro de que quieres continuar?",
  "notification_requests.confirm_dismiss_multiple.title": "¿Deseas descartar las solicitudes de notificación?",
  "notification_requests.dismiss": "Descartar",
  "notification_requests.dismiss_multiple": "{count, plural, one {Descartar # solicitud…} other {Descartar # solicitudes…}}",
  "notification_requests.edit_selection": "Editar",
  "notification_requests.exit_selection": "Hecho",
  "notification_requests.explainer_for_limited_account": "Las notificaciones de esta cuenta han sido filtradas, ya que la cuenta ha sido limitada por un moderador.",
  "notification_requests.explainer_for_limited_remote_account": "Las notificaciones de esta cuenta han sido filtradas, ya que la cuenta o su servidor ha sido limitada por un moderador.",
  "notification_requests.maximize": "Maximizar",
  "notification_requests.minimize_banner": "Minimizar banner de notificaciones filtradas",
  "notification_requests.notifications_from": "Notificaciones de {name}",
  "notification_requests.title": "Notificaciones filtradas",
  "notification_requests.view": "Ver notificaciones",
  "notifications.clear": "Limpiar notificaciones",
  "notifications.clear_confirmation": "¿Estás seguro de que quieres eliminar definitivamente todas tus notificaciones?",
  "notifications.clear_title": "¿Limpiar notificaciones?",
  "notifications.column_settings.admin.report": "Nuevas denuncias:",
  "notifications.column_settings.admin.sign_up": "Registros nuevos:",
  "notifications.column_settings.alert": "Notificaciones de escritorio",
  "notifications.column_settings.collections": "Colecciones:",
  "notifications.column_settings.favourite": "Favoritos:",
  "notifications.column_settings.filter_bar.advanced": "Mostrar todas las categorías",
  "notifications.column_settings.filter_bar.category": "Barra de filtrado rápido",
  "notifications.column_settings.follow": "Nuevos seguidores:",
  "notifications.column_settings.follow_request": "Nuevas solicitudes de seguimiento:",
  "notifications.column_settings.group": "Grupo",
  "notifications.column_settings.mention": "Menciones:",
  "notifications.column_settings.poll": "Resultados de la votación:",
  "notifications.column_settings.push": "Notificaciones push",
  "notifications.column_settings.quote": "Citas:",
  "notifications.column_settings.reblog": "Impulsos:",
  "notifications.column_settings.show": "Mostrar en columna",
  "notifications.column_settings.sound": "Reproducir sonido",
  "notifications.column_settings.status": "Nuevas publicaciones:",
  "notifications.column_settings.unread_notifications.category": "Notificaciones sin leer",
  "notifications.column_settings.unread_notifications.highlight": "Destacar notificaciones no leídas",
  "notifications.column_settings.update": "Ediciones:",
  "notifications.filter.all": "Todos",
  "notifications.filter.boosts": "Impulsos",
  "notifications.filter.collections": "Colecciones",
  "notifications.filter.favourites": "Favoritos",
  "notifications.filter.follows": "Seguidores",
  "notifications.filter.mentions": "Menciones",
  "notifications.filter.polls": "Resultados de la votación",
  "notifications.filter.statuses": "Actualizaciones de gente a la que sigues",
  "notifications.grant_permission": "Conceder permiso.",
  "notifications.group": "{count} notificaciones",
  "notifications.mark_as_read": "Marcar todas las notificaciones como leídas",
  "notifications.permission_denied": "No se pueden habilitar las notificaciones de escritorio, ya que se denegó el permiso",
  "notifications.permission_denied_alert": "No se pueden habilitar las notificaciones de escritorio, ya que el permiso del navegador fue denegado anteriormente",
  "notifications.permission_required": "Las notificaciones de escritorio no están disponibles porque no se ha concedido el permiso requerido.",
  "notifications.policy.accept": "Aceptar",
  "notifications.policy.accept_hint": "Mostrar en notificaciones",
  "notifications.policy.drop": "Ignorar",
  "notifications.policy.drop_hint": "Enviar al vacío, no volver a mostrar nunca",
  "notifications.policy.filter": "Filtrar",
  "notifications.policy.filter_bots_hint": "Cuentas etiquetadas como automatizadas",
  "notifications.policy.filter_bots_title": "Bots",
  "notifications.policy.filter_hint": "Enviar a la bandeja de entrada de notificaciones filtradas",
  "notifications.policy.filter_limited_accounts_hint": "Limitadas por los moderadores del servidor",
  "notifications.policy.filter_limited_accounts_title": "Cuentas moderadas",
  "notifications.policy.filter_new_accounts.hint": "Creadas durante {days, plural, one {el último día} other {los últimos # días}}",
  "notifications.policy.filter_new_accounts_title": "Cuentas nuevas",
  "notifications.policy.filter_not_followers_hint": "Incluyendo personas que te han estado siguiendo desde hace menos de {days, plural, one {un día} other {# días}}",
  "notifications.policy.filter_not_followers_title": "Personas que no te siguen",
  "notifications.policy.filter_not_following_hint": "Hasta que las apruebes manualmente",
  "notifications.policy.filter_not_following_title": "Personas que no sigues",
  "notifications.policy.filter_private_mentions_hint": "Filtradas a menos que sea una respuesta a tu propia mención o si sigues al remitente",
  "notifications.policy.filter_private_mentions_title": "Menciones privadas no solicitadas",
  "notifications.policy.title": "Gestionar notificaciones de…",
  "notifications_permission_banner.enable": "Habilitar notificaciones de escritorio",
  "notifications_permission_banner.how_to_control": "Para recibir notificaciones cuando Mastodon no esté abierto, habilite las notificaciones de escritorio. Puedes controlar con precisión qué tipos de interacciones generan notificaciones de escritorio a través del botón {icon} de arriba una vez que estén habilitadas.",
  "notifications_permission_banner.title": "Nunca te pierdas nada",
  "onboarding.follows.back": "Volver",
  "onboarding.follows.empty": "Desafortunadamente, no se pueden mostrar resultados en este momento. Puedes intentar usar la búsqueda o navegar por la página de exploración para encontrar gente a la que seguir, o inténtalo de nuevo más tarde.",
  "onboarding.follows.next": "Siguiente: Configura tu perfil",
  "onboarding.follows.search": "Buscar",
  "onboarding.follows.title": "Sigue personas para comenzar",
  "onboarding.profile.discoverable": "Hacer que mi perfil aparezca en búsquedas",
  "onboarding.profile.discoverable_hint": "Cuando permites que tu perfil aparezca en búsquedas en Mastodon, tus publicaciones pueden aparecer en los resultados de búsqueda y en las tendencias, y tu perfil puede ser sugerido a personas con intereses similares a los tuyos.",
  "onboarding.profile.display_name": "Nombre para mostrar",
  "onboarding.profile.display_name_hint": "Tu nombre completo o tu apodo…",
  "onboarding.profile.finish": "Fiinalizar",
  "onboarding.profile.note": "Biografía",
  "onboarding.profile.note_hint": "Puedes @mencionar a otras personas o #etiquetas…",
  "onboarding.profile.title": "Configuración del perfil",
  "onboarding.profile.upload_avatar": "Subir foto de perfil",
  "onboarding.profile.upload_header": "Subir encabezado de perfil",
  "password_confirmation.exceeds_maxlength": "La contraseña de confirmación supera la longitud máxima permitida",
  "password_confirmation.mismatching": "La contraseña de confirmación no coincide",
  "picture_in_picture.restore": "Restaurar",
  "poll.closed": "Cerrada",
  "poll.refresh": "Actualizar",
  "poll.reveal": "Ver resultados",
  "poll.total_people": "{count, plural, one {# persona} other {# personas}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# votos}}",
  "poll.vote": "Votar",
  "poll.voted": "Has votado a favor de esta respuesta",
  "poll.votes": "{votes, plural, one {# voto} other {# votes}}",
  "poll_button.add_poll": "Añadir una encuesta",
  "poll_button.remove_poll": "Eliminar encuesta",
  "privacy.change": "Ajustar privacidad",
  "privacy.direct.long": "Todos los mencionados en la publicación",
  "privacy.direct.short": "Mención privada",
  "privacy.private.long": "Solo tus seguidores",
  "privacy.private.short": "Seguidores",
  "privacy.public.long": "Cualquiera dentro y fuera de Mastodon",
  "privacy.public.short": "Público",
  "privacy.quote.anyone": "{visibility}, citas permitidas",
  "privacy.quote.disabled": "{visibility}, citas desactivadas",
  "privacy.quote.limited": "{visibility}, citas limitadas",
  "privacy.unlisted.additional": "Esto funciona exactamente igual que «público», excepto que la publicación no aparecerá en las transmisiones en vivo ni en las etiquetas, en «explorar» ni en la búsqueda de Mastodon, incluso si has optado por ello en toda tu cuenta.",
  "privacy.unlisted.long": "Oculto de los resultados de búsquedas, tendencias y cronologías públicas de Mastodon",
  "privacy.unlisted.short": "Pública, pero discreta",
  "privacy_policy.last_updated": "Actualizado por última vez {date}",
  "privacy_policy.title": "Política de Privacidad",
  "quote_error.edit": "No se pueden añadir citas mientras un post está siendo editado.",
  "quote_error.poll": "No se permite citar encuestas.",
  "quote_error.private_mentions": "Citar no está disponible sin menciones directas.",
  "quote_error.quote": "Solo se permite una cita a la vez.",
  "quote_error.unauthorized": "No estás autorizado a citar esta publicación.",
  "quote_error.upload": "No se permite citar con archivos multimedia.",
  "recommended": "Recomendado",
  "refresh": "Actualizar",
  "regeneration_indicator.please_stand_by": "Espera, por favor.",
  "regeneration_indicator.preparing_your_home_feed": "Preparando tu página de inicio…",
  "relative_time.days": "{number} d",
  "relative_time.full.days": "{number, plural, one {# día} other {# días hace}}",
  "relative_time.full.hours": "{number, plural, one {# hora} other {# horas}} hace",
  "relative_time.full.just_now": "ahora mismo",
  "relative_time.full.minutes": "Hace {number, plural, one {# minute} other {# minutos}}",
  "relative_time.full.seconds": "Hace {number, plural, one {# second} other {# segundos}}",
  "relative_time.hours": "{number} h",
  "relative_time.just_now": "ahora",
  "relative_time.minutes": "{number} m",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "hoy",
  "remove_quote_hint.button_label": "Entendido",
  "remove_quote_hint.message": "Puedes hacerlo desde el menú de opciones {icon}.",
  "remove_quote_hint.title": "¿Quieres eliminar tu publicación citada?",
  "reply_indicator.attachments": "{count, plural, one {# adjunto} other {# adjuntos}}",
  "reply_indicator.cancel": "Cancelar",
  "reply_indicator.poll": "Encuesta",
  "report.block": "Bloquear",
  "report.block_explanation": "No verás sus publicaciones. Ellos no podrán ver tus publicaciones ni seguirte. Podrán saber que están bloqueados.",
  "report.categories.legal": "Legal",
  "report.categories.other": "Otro",
  "report.categories.spam": "Spam",
  "report.categories.violation": "El contenido viola una o más reglas del servidor",
  "report.category.subtitle": "Selecciona la mejor coincidencia",
  "report.category.title_account": "Cuéntanos qué está pasando con este perfil",
  "report.category.title_collection": "Cuéntanos qué está pasando con esta colección",
  "report.category.title_status": "Cuéntanos qué está pasando con esta publicación",
  "report.close": "Realizado",
  "report.comment.title": "¿Hay algo más que creas que deberíamos saber?",
  "report.forward": "Reenviar a {target}",
  "report.forward_hint": "La cuenta es de otro servidor. ¿Enviar también una copia anónima del informe allí?",
  "report.mute": "Silenciar",
  "report.mute_explanation": "No verás sus publicaciones. Todavía pueden seguirte y ver tus publicaciones y no sabrán que están silenciados.",
  "report.next": "Siguiente",
  "report.placeholder": "Comentarios adicionales",
  "report.reasons.dislike": "No me gusta",
  "report.reasons.dislike_description": "No es algo que quieres ver",
  "report.reasons.legal": "Es ilegal",
  "report.reasons.legal_description": "Crees que viola la ley de tu país o el país del servidor",
  "report.reasons.other": "Es algo más",
  "report.reasons.other_description": "El problema no encaja en otras categorías",
  "report.reasons.spam": "Es spam",
  "report.reasons.spam_description": "Enlaces maliciosos, interacciones falsas, o respuestas repetitivas",
  "report.reasons.violation": "Infringe las reglas del servidor",
  "report.reasons.violation_description": "Eres consciente de que infringe normas específicas",
  "report.rules.subtitle": "Selecciona todas las que apliquen",
  "report.rules.title": "¿Cuáles reglas se están infringiendo?",
  "report.statuses.subtitle": "Seleccione todas las que apliquen",
  "report.statuses.title": "¿Hay alguna publicación que respalde esta denuncia?",
  "report.submission_error": "No se pudo enviar el informe",
  "report.submission_error_details": "Por favor, comprueba tu conexión a internet y vuelve a intentarlo más tarde.",
  "report.submit": "Enviar",
  "report.target": "Denunciando a {target}",
  "report.thanks.take_action": "Aquí están tus opciones para controlar lo que ves en Mastodon:",
  "report.thanks.take_action_actionable": "Mientras revisamos esto, puedes tomar medidas contra @{name}:",
  "report.thanks.title": "¿No quieres ver esto?",
  "report.thanks.title_actionable": "Gracias por denunciar, revisaremos esto.",
  "report.unfollow": "Dejar de seguir @{name}",
  "report.unfollow_explanation": "Estás siguiendo esta cuenta. Para dejar de ver sus publicaciones en tu página de inicio, deja de seguirla.",
  "report_notification.attached_statuses": "{count, plural, one {{count} publicación} other {{count} publicaciones}} adjunta(s)",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "contenido ilegal",
  "report_notification.categories.other": "Otro",
  "report_notification.categories.other_sentence": "otra",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Infracción de regla",
  "report_notification.categories.violation_sentence": "infracción de regla",
  "report_notification.open": "Abrir denuncia",
  "search.clear": "Limpiar búsqueda",
  "search.no_recent_searches": "Sin búsquedas recientes",
  "search.placeholder": "Buscar",
  "search.quick_action.account_search": "Perfiles que coinciden con {x}",
  "search.quick_action.go_to_account": "Ir al perfil {x}",
  "search.quick_action.go_to_hashtag": "Ir a la etiqueta {x}",
  "search.quick_action.open_url": "Abrir enlace en Mastodon",
  "search.quick_action.status_search": "Publicaciones que coinciden con {x}",
  "search.search_or_paste": "Buscar o pegar URL",
  "search_popout.full_text_search_disabled_message": "No disponible en {domain}.",
  "search_popout.full_text_search_logged_out_message": "Solo disponible al iniciar sesión.",
  "search_popout.language_code": "Código de idioma ISO",
  "search_popout.options": "Opciones de búsqueda",
  "search_popout.quick_actions": "Acciones rápidas",
  "search_popout.recent": "Búsquedas recientes",
  "search_popout.specific_date": "fecha específica",
  "search_popout.user": "usuario",
  "search_results.accounts": "Perfiles",
  "search_results.all": "Todos",
  "search_results.collections": "Colecciones",
  "search_results.hashtags": "Etiquetas",
  "search_results.no_results": "No hay resultados.",
  "search_results.no_search_yet": "Intenta buscar publicaciones, perfiles o etiquetas.",
  "search_results.see_all": "Ver todos",
  "search_results.statuses": "Publicaciones",
  "search_results.title": "Busqueda de “{q}”",
  "server_banner.about_active_users": "Personas utilizando este servidor durante los últimos 30 días (Usuarios Activos Mensuales)",
  "server_banner.active_users": "usuarios activos",
  "server_banner.administered_by": "Administrado por:",
  "server_banner.is_one_of_many": "{domain} es uno de los varios servidores independientes de Mastodon que puedes usar para participar en el fediverso.",
  "server_banner.more_about_this_server": "Más información sobre este servidor",
  "server_banner.server_stats": "Estadísticas del servidor:",
  "sign_in_banner.create_account": "Crear cuenta",
  "sign_in_banner.follow_anyone": "Sigue a cualquier persona en el fediverso y velo todo en orden cronológico. Sin algoritmos, sin anuncios o titulares engañosos.",
  "sign_in_banner.mastodon_is": "Mastodon es el mejor modo de mantenerse al día sobre qué está ocurriendo.",
  "sign_in_banner.sign_in": "Iniciar sesión",
  "sign_in_banner.sso_redirect": "Iniciar sesión o Registrarse",
  "skip_links.hotkey": "<span>Atajos</span> {hotkey}",
  "skip_links.skip_to_content": "Ir al contenido principal",
  "skip_links.skip_to_navigation": "Ir a la navegación principal",
  "status.admin_account": "Abrir interfaz de moderación para @{name}",
  "status.admin_domain": "Abrir interfaz de moderación para {domain}",
  "status.admin_status": "Abrir este estado en la interfaz de moderación",
  "status.all_disabled": "Los impulsos y las citas están desactivadas",
  "status.block": "Bloquear a @{name}",
  "status.bookmark": "Añadir marcador",
  "status.cancel_reblog_private": "Deshacer impulso",
  "status.cannot_quote": "No está permitido citar esta publicación",
  "status.cannot_reblog": "Esta publicación no puede ser impulsada",
  "status.contains_quote": "Contiene cita",
  "status.context.loading": "Cargando más respuestas",
  "status.context.loading_error": "No se pudieron cargar nuevas respuestas",
  "status.context.loading_success": "Nuevas respuestas cargadas",
  "status.context.more_replies_found": "Se han encontrado más respuestas",
  "status.context.retry": "Reintentar",
  "status.context.show": "Mostrar",
  "status.continued_thread": "Hilo continuado",
  "status.copy": "Copiar enlace al estado",
  "status.delete": "Eliminar",
  "status.delete.success": "Publicación eliminada",
  "status.detailed_status": "Vista de conversación detallada",
  "status.direct": "Mención privada @{name}",
  "status.direct_indicator": "Mención privada",
  "status.edit": "Editar",
  "status.edited": "Última edición {date}",
  "status.edited_x_times": "Editado {count, plural, one {{count} time} other {{count} veces}}",
  "status.embed": "Obtener código para incrustar",
  "status.favourite": "Favorito",
  "status.favourites_count": "{count, plural,one {{counter} favorito}other {{counter} favoritos}}",
  "status.filter": "Filtrar esta publicación",
  "status.history.created": "{name} creó {date}",
  "status.history.edited": "{name} editado {date}",
  "status.load_more": "Cargar más",
  "status.media.open": "Haz clic para abrir",
  "status.media.show": "Haz clic para mostrar",
  "status.media_hidden": "Contenido multimedia oculto",
  "status.mention": "Mencionar @{name}",
  "status.more": "Más",
  "status.mute": "Silenciar @{name}",
  "status.mute_conversation": "Silenciar conversación",
  "status.open": "Expandir estado",
  "status.pin": "Fijar",
  "status.quote": "Citar",
  "status.quote.cancel": "Cancelar cita",
  "status.quote_error.blocked_account_hint.title": "Esta publicación se ocultó porque bloqueaste a @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Este post está oculto porque bloqueaste {domain}.",
  "status.quote_error.filtered": "Oculto debido a uno de tus filtros",
  "status.quote_error.limited_account_hint.action": "Mostrar de todas formas",
  "status.quote_error.limited_account_hint.title": "Esta cuenta ha sido ocultada por los moderadores de {domain}.",
  "status.quote_error.muted_account_hint.title": "Esta publicación está oculta porque silenciaste a @{name}.",
  "status.quote_error.not_available": "Publicación no disponible",
  "status.quote_error.pending_approval": "Publicación pendiente",
  "status.quote_error.pending_approval_popout.body": "En Mastodon, puedes controlar si alguien puede citarte. Esta publicación está pendiente mientras obtenemos la aprobación del autor original.",
  "status.quote_error.revoked": "Publicación eliminada por el autor",
  "status.quote_followers_only": "Solo los seguidores pueden citar esta publicación",
  "status.quote_manual_review": "El autor la revisará manualmente",
  "status.quote_noun": "Cita",
  "status.quote_policy_change": "Cambia quién puede citarte",
  "status.quote_post_author": "Ha citado una publicación de @{name}",
  "status.quote_private": "Las publicaciones privadas no pueden citarse",
  "status.quotes.empty": "Nadie ha citado esta publicación todavía. Cuando alguien lo haga, aparecerá aquí.",
  "status.quotes.local_other_disclaimer": "Las citas rechazadas pro el autor no serán mostradas.",
  "status.quotes.remote_other_disclaimer": "Solo las citas hechas por {domain} están garantizadas a ser vistas aquí. Las citas rechazadas por el autor no serán mostradas.",
  "status.quotes_count": "{count, plural,one {{counter} cita} other {{counter} citas}}",
  "status.read_more": "Leer más",
  "status.reblog": "Impulsar",
  "status.reblog_or_quote": "Impulsar o citar",
  "status.reblog_private": "Compartir de nuevo con tus seguidores",
  "status.reblogged_by": "Impulsado por {name}",
  "status.reblogs.empty": "Nadie impulsó esta publicación todavía. Cuando alguien lo haga, aparecerá aquí.",
  "status.reblogs_count": "{count, plural,one {{counter} impulso} other {{counter} impulsos}}",
  "status.redraft": "Eliminar y volver a redactar",
  "status.remove_bookmark": "Eliminar marcador",
  "status.remove_favourite": "Eliminar de favoritos",
  "status.remove_quote": "Eliminar",
  "status.replied_in_thread": "Respondido en el hilo",
  "status.replied_to": "Respondió a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder al hilo",
  "status.report": "Reportar @{name}",
  "status.request_quote": "Solicitud de citación",
  "status.revoke_quote": "Eliminar mi publicación de la cita de @{name}",
  "status.sensitive_warning": "Contenido sensible",
  "status.share": "Compartir",
  "status.show_less_all": "Mostrar menos para todo",
  "status.show_more_all": "Mostrar más para todo",
  "status.show_original": "Mostrar original",
  "status.title.with_attachments": "{user} ha publicado {attachmentCount, plural, one {un adjunto} other {{attachmentCount} adjuntos}}",
  "status.translate": "Traducir",
  "status.translated_from_with": "Traducido del {lang} usando {provider}",
  "status.uncached_media_warning": "Vista previa no disponible",
  "status.unmute_conversation": "Dejar de silenciar conversación",
  "status.unpin": "Dejar de fijar",
  "subscribed_languages.lead": "Solo las publicaciones en los idiomas seleccionados aparecerán en tu inicio y enlistará las líneas de tiempo después del cambio. Selecciona ninguno para recibir publicaciones en todos los idiomas.",
  "subscribed_languages.save": "Guardar cambios",
  "subscribed_languages.target": "Cambiar idiomas suscritos para {target}",
  "tabs_bar.home": "Inicio",
  "tabs_bar.menu": "Menú",
  "tabs_bar.notifications": "Notificaciones",
  "tabs_bar.publish": "Nueva publicación",
  "tabs_bar.quick_links": "Enlaces rápidos",
  "tabs_bar.search": "Buscar",
  "tag.remove": "Eliminar",
  "terms_of_service.effective_as_of": "En vigor a partir del {date}",
  "terms_of_service.title": "Condiciones del servicio",
  "terms_of_service.upcoming_changes_on": "Próximos cambios el {date}",
  "time_remaining.days": "{number, plural, one {# día restante} other {# días restantes}}",
  "time_remaining.hours": "{number, plural, one {# hora restante} other {# horas restantes}}",
  "time_remaining.minutes": "{number, plural, one {# minuto restante} other {# minutos restantes}}",
  "time_remaining.moments": "Momentos restantes",
  "time_remaining.seconds": "{number, plural, one {# segundo restante} other {# segundos restantes}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persona} other {{counter} personas}} en los últimos {days, plural, one {días} other {{days} días}}",
  "trends.trending_now": "Tendencia ahora",
  "ui.beforeunload": "Tu borrador se perderá si abandonas Mastodon.",
  "units.short.billion": "{count} MM",
  "units.short.million": "{count} M",
  "units.short.thousand": "{count} K",
  "upload_area.title": "Arrastra y suelta para subir",
  "upload_button.label": "Añadir imágenes, un video o un archivo de audio",
  "upload_error.limit": "Límite de subida de archivos excedido.",
  "upload_error.poll": "No se permite subir archivos con las encuestas.",
  "upload_error.quote": "No se permite subir archivos a las citas.",
  "upload_form.drag_and_drop.instructions": "Para recoger un archivo adjunto, pulsa la barra espaciadora o la tecla Intro. Mientras arrastras, usa las teclas de flecha para mover el archivo adjunto en cualquier dirección. Vuelve a pulsar la barra espaciadora o la tecla Intro para soltar el archivo adjunto en su nueva posición, o pulsa la tecla Escape para cancelar.",
  "upload_form.drag_and_drop.on_drag_cancel": "Arrastre cancelado. El archivo adjunto {item} fue eliminado.",
  "upload_form.drag_and_drop.on_drag_end": "El archivo adjunto {item} fue eliminado.",
  "upload_form.drag_and_drop.on_drag_over": "El archivo adjunto {item} fue movido.",
  "upload_form.drag_and_drop.on_drag_start": "Recogidos los archivos adjuntos {item}.",
  "upload_form.edit": "Editar",
  "upload_progress.label": "Subiendo...",
  "upload_progress.processing": "Procesando…",
  "username.taken": "Ese nombre de usuario está ocupado. Prueba con otro",
  "video.close": "Cerrar video",
  "video.download": "Descargar archivo",
  "video.exit_fullscreen": "Salir de pantalla completa",
  "video.expand": "Expandir vídeo",
  "video.fullscreen": "Pantalla completa",
  "video.hide": "Ocultar vídeo",
  "video.mute": "Silenciar",
  "video.pause": "Pausar",
  "video.play": "Reproducir",
  "video.skip_backward": "Saltar atrás",
  "video.skip_forward": "Saltar adelante",
  "video.unmute": "Dejar de silenciar",
  "video.volume_down": "Bajar el volumen",
  "video.volume_up": "Subir el volumen",
  "visibility_modal.button_title": "Establece la visibilidad",
  "visibility_modal.direct_quote_warning.text": "Si guardas la siguiente configuración, se mostrará un enlace en vez de la cita incrustada.",
  "visibility_modal.direct_quote_warning.title": "Las citas no se pueden incluir en menciones privadas",
  "visibility_modal.header": "Visibilidad e interacción",
  "visibility_modal.helper.direct_quoting": "Las menciones privadas escritas en Mastodon no pueden ser citadas por otros usuarios.",
  "visibility_modal.helper.privacy_editing": "La visibilidad no se puede cambiar después de que se haya hecho una publicación.",
  "visibility_modal.helper.privacy_private_self_quote": "Las citas propias de publicaciones privadas no pueden hacerse públicas.",
  "visibility_modal.helper.private_quoting": "Las publicaciones solo para seguidores creadas en Mastodon no pueden ser citadas por otros.",
  "visibility_modal.helper.unlisted_quoting": "Cuando las personas te citen, sus publicaciones también se ocultarán de las cronologías de tendencias.",
  "visibility_modal.instructions": "Controla quién puede interactuar con esta publicación. También puedes modificar la configuración a todas las publicaciones futuras accediendo a <link>Preferencias > Publicaciones por defecto</link>.",
  "visibility_modal.privacy_label": "Visibilidad",
  "visibility_modal.quote_followers": "Solo seguidores",
  "visibility_modal.quote_label": "Quién puede citar",
  "visibility_modal.quote_nobody": "Solo yo",
  "visibility_modal.quote_public": "Cualquiera",
  "visibility_modal.save": "Guardar"
}
